<template>
    <div class="pagebox">
        <!-- 顶部 -->
        <PHeader></PHeader>

        <div class="fastwish_start">
            <!-- 加载动画 -->
            <div class="loading_box" v-if="LoadingShow"><div class="loadimg"></div><div class="loadicon"></div></div>
            <!-- 测评、偏好 导入 -->
            <div class="testlikeimportbox" id="testlikeimportlayerids" v-show="TestLikeImportShow">
                <div class="tbox" id="testlikeimportboxids">
                    <div class="con_box">
                        <div class="clear"></div>
                        <div class="topbox">
                            <img class="zizhushou" src="../../assets/images/aizhushou.png" alt="" />
                            <i class="el-icon-close" @click.prevent="SkipCloseStep()"></i>
                        </div>
                        <!-- 问答模块 -->
                        <el-scrollbar wrap-class="scrollbar-wrapper" class="answerbox" id="answerboxid">
                            <div class="toptip" v-if="UserLikeData.MessageList.length>0">历史记录</div>
                            <div class="contip" v-if="QuestionTipsShow">
                                <div class="tipmark">
                                    <div class="sili">
                                        您可以这样输入：<br/><span style="margin-left:28px;">我是男生，性格内向，想去一线或新一线城市上大学，想学电子信息、计算机、航空航天、电气、自动化、能源动力相关的专业，学费2万内，只接受公办或民办院校。</span>
                                    </div>
                                    <i class="el-icon-close" @click.prevent="QuestionTipsBtn()"></i></div>
                            </div>
                            <div class="clear"></div>
                            <!-- <div class="answercontent" v-html="AnswerContent"></div> -->
                            <!-- <div class="chatmesgbox">
                                <div class="chatmesg">我想去一线城市、新一线城市我想去一线城市、新一线城市我想去一线城市、新一线城市我想去一线城市、新一线城市</div>
                            </div> -->
                            <div class="usermesgbox" v-for="(item,index) in UserLikeData.MessageList" :key="index">
                                <div class="usermesg">{{item}}</div>
                            </div>
                            <div class="line"></div>
                            <div class="clear" style="height:50px;background-color:#fff;"></div>
                        </el-scrollbar>
                        <div class="inputdiv">
                            <div class="inbox">
                                <textarea v-model="UserLikeData.Message" autocomplete="off" placeholder="Shift + Enter 换行 , Enter 发送" class="el-textarea__inner" id="UserMessageInput"></textarea>
                                <div class="sendbox">
                                    <div class="lbtn">
                                        <div class="cbtn" @click.prevent="GetTestList()"><i class="el-icon-upload2"></i>导入测评</div>
                                        <div class="qutips iconfont" @click.prevent="QuestionTipsBtn()">&#xe65f;</div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="rbtn">
                                        <div class="sendbtn el-icon-top" @click.prevent="WriterText()"></div>
                                    </div>
                                    <div class="clear"></div>
                                </div>
                            </div>
                        </div>
                        <div class="bot_botton">
                            <div class="backbtn" @click.prevent="SkipCloseStep()">取消</div>
                            <div class="backbtn" @click.prevent="SkipCloseStep()">跳过该步骤</div>
                            <div class="backbtn" @click.prevent="SkipReset()">重置</div>
                            <div class="botbtn" @click.prevent="ImportLikeShow()">开始智能分析</div>
                        </div>
                        <!-- 选择测评 -->
                        <div class="importbox" v-if="IsImportTest">
                            <div class="flbox">
                                <div class="flback">
                                    <!--选测评-->
                                    <div class="fltit">
                                        <div class="tit">导入测评</div>
                                        <i class="el-icon-close" @click.prevent="ImpotTestClose()"></i>
                                    </div>
                                    <div class="testlist" id="testlistids">
                                        <div class="tbtn">
                                            <div class="addtest" @click.prevent="MakeTestBoxShow()"><i class="iconfont">&#xe682;</i>去做测评</div>
                                            <div class="refresh" @click.prevent="GetTestList(1)"><i class="iconfont">&#xe627;</i>刷新</div>
                                        </div>
                                        <el-scrollbar wrap-class="scrollbar-wrapper" class="testlistscroll">
                                            <div v-if="TestListData.length>0" style="width:100%;">
                                                <div class="list" v-for="(item,index) in TestListData" :key="index" @click.prevent="TestCheck(item)">
                                                    <div class="index">{{index+1}}</div>
                                                    <div class="name">{{GetTestTypeName(item.TestType)}}</div>
                                                    <div class="time">{{item.CreateTime}}</div>
                                                    <div class="clear"></div>
                                                </div>
                                            </div>
                                            <div v-else style="text-align:center;">
                                                <div class="notest">暂无测评数据！</div>
                                                <div class="iconfont">&#xe67c;</div>
                                                <div class="totest" @click.prevent="MakeTestBoxShow()">去做测评<i class="el-icon-arrow-right"></i></div>
                                            </div>
                                        </el-scrollbar>
                                    </div>
                                    <div class="testback">
                                        <div class="tbn" @click.prevent="ImpotTestClose()">返回</div>
                                    </div>
                                    <!--做测评-->
                                    <div class="cplayer" v-if="MakeTestShow" @click.prevent="MakeTestBoxClose()"></div>
                                    <div class="cpleft" id="MakeTestBoxId">
                                        <span class="el-icon-arrow-left" v-if="MakeTestShow" @click.prevent="MakeTestBoxClose()"></span>
                                        <span class="el-icon-arrow-right" v-if="!MakeTestShow" @click.prevent="MakeTestBoxShow()"></span>
                                        <div class="ltit">做测评<span class="el-icon-close" @click.prevent="MakeTestBoxClose()"></span></div>
                                        <el-scrollbar wrap-class="scrollbar-wrapper" class="litem">
                                            <div class="testbtn">
                                                <div class="cname">{{GetTestTypeName(6)}}</div>
                                                <div class="bul">
                                                    <div class="b" @click.prevent="GoTest(6)"><i class="el-icon-document"></i>开始测评</div>
                                                    <div class="b tag-read" :data-clipboard-text="TestBaseUrl+GetTestUrl(6)" @click.prevent="CopyTest(6)"><i class="el-icon-document-copy"></i>复制链接</div>
                                                </div>
                                            </div>
                                            <div class="testbtn">
                                                <div class="cname">{{GetTestTypeName(1)}}</div>
                                                <div class="bul">
                                                    <div class="b" @click.prevent="GoTest(1)"><i class="el-icon-document"></i>开始测评</div>
                                                    <div class="b tag-read" :data-clipboard-text="TestBaseUrl+GetTestUrl(1)" @click.prevent="CopyTest(1)"><i class="el-icon-document-copy"></i>复制链接</div>
                                                </div>
                                            </div>
                                            <div class="testbtn">
                                                <div class="cname">{{GetTestTypeName(2)}}</div>
                                                <div class="bul">
                                                    <div class="b" @click.prevent="GoTest(2)"><i class="el-icon-document"></i>开始测评</div>
                                                    <div class="b tag-read" :data-clipboard-text="TestBaseUrl+GetTestUrl(2)" @click.prevent="CopyTest(2)"><i class="el-icon-document-copy"></i>复制链接</div>
                                                </div>
                                            </div>
                                            <div class="testbtn">
                                                <div class="cname">{{GetTestTypeName(3)}}</div>
                                                <div class="bul">
                                                    <div class="b" @click.prevent="GoTest(3)"><i class="el-icon-document"></i>开始测评</div>
                                                    <div class="b tag-read" :data-clipboard-text="TestBaseUrl+GetTestUrl(3)" @click.prevent="CopyTest(3)"><i class="el-icon-document-copy"></i>复制链接</div>
                                                </div>
                                            </div>
                                            <div class="testbtn">
                                                <div class="cname">{{GetTestTypeName(4)}}</div>
                                                <div class="bul">
                                                    <div class="b" @click.prevent="GoTest(4)"><i class="el-icon-document"></i>开始测评</div>
                                                    <div class="b tag-read" :data-clipboard-text="TestBaseUrl+GetTestUrl(4)" @click.prevent="CopyTest(4)"><i class="el-icon-document-copy"></i>复制链接</div>
                                                </div>
                                            </div>
                                            <div class="clear" style="height:20px;"></div>
                                        </el-scrollbar>
                                    </div>
                                    <div class="testiframebox" v-if="TestIframeShow">
                                        <div class="addiframe" id="addiframebox"></div>
                                        <div class="ifbtn">
                                            <div class="ibtn" @click.prevent="TestIframeBack()">返回</div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <!--保存分析-->
                        <div class="analysislayer" v-if="AnalysisLayerShow">
                            <div class="analysisbox">
                                <div class="thinking">
                                    <div class="txt">AI正在分析您的需求…</div>
                                    <div class="asico"><div class="loadimg"></div><div class="loadicon"></div></div>
                                    <div class="clear"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 设置偏好弹层 -->
            <div class="layerbox" v-show="LayerShow">
                <div class="lbox">
                    <div class="tab_box">
                        <div class="tab">
                            <img src="../../assets/images/ai-icon.png" alt="" />
                            <span style="margin-left:10px;"><span class="headanimate1">AI填报</span><i class="el-icon-right"></i><span class="headanimate2">选择偏好</span><i class="el-icon-right"></i><span class="headanimate3">智能推荐</span></span>
                        </div>
                        <i class="close iconfont" @click.prevent="LayerShow = false">&#xe64d;</i>
                    </div>
                    <!-- 偏好设置 -->
                    <div class="tab_con">
                        <div class="clear"></div>
                        <el-scrollbar wrap-class="scrollbar-wrapper" class="tab_scroll">
                            <div class="s_box" style="margin-top:5px;">
                                <div class="tit">院校地区：</div>
                                <div class="box">
                                    <span class="item" :class="query.CollegeAreaList.length==0?'on':''" @click.prevent="CollegeAreaListReset()">不限</span>
                                    <span class="type" @click.prevent="InvertCheck()">省份/城市反选<i class="iconfont" style="color:#2c93a4;">&#xe68a;</i></span>
                                    <el-tooltip class="type" :class="query.IsFirstCityCheck?'on':''" effect="dark" content="北京、上海、广州、深圳" placement="top-start">
                                        <el-button @click.prevent="FirstCityReset()">一线城市<i class="iconfont" :style="{'color':(query.IsFirstCityCheck?'#dfdfdf':'#df4a4a')}">&#xe8f4;</i></el-button>
                                    </el-tooltip>
                                    <el-tooltip class="type" :class="query.IsNewFirstCityCheck?'on':''" effect="dark" content="成都、杭州、重庆、武汉、苏州、西安、南京、长沙、郑州、天津、合肥、青岛、东莞、宁波、佛山" placement="top-start">
                                        <el-button @click.prevent="NewFirstCityReset()">新一线城市<i class="iconfont" :style="{'color':(query.IsNewFirstCityCheck?'#dfdfdf':'#007322')}">&#xe649;</i></el-button>
                                    </el-tooltip>
                                    <span class="ltxt" v-if="CityTotalNumber>0" style="font-size:12px;">共选择了<span style="color:rgba(var(--themecolor),1);">{{CityTotalNumber}}</span>个城市</span>
                                    <div class="clear"></div>
                                    <el-popover v-for="item_p in CollegeScreen.CollegeAreaList" :key="item_p.ProvinceId" trigger="hover" placement="bottom" width="450" :open-delay="50" popper-class="search_city_popover">
                                        <div class="search_citybox">
                                            <div class="citem" :class="item_p.CheckNumber==item_p.CityList.length?'on':''" @click.prevent="CollegeAreaListCheckAll(item_p)">全部</div>
                                            <!-- <span class="nolook" @click.prevent="DontLook(item_p)">不看当前省份选中的城市</span> -->
                                            <div class="clear"></div>
                                            <div class="citem" :class="(query.CollegeAreaList.find(f=>f.AreaId==item_c.CityId)||item_p.CheckNumber==item_p.CityList.length)?'on':''" v-for="item_c in item_p.CityList" :key="item_c.CityId" @click.prevent="CollegeAreaListCheck(item_p,item_c)">{{item_c.CityName}}</div>
                                        </div>
                                        <el-button slot="reference">{{item_p.ProvinceName}}<i class="el-icon-arrow-down"></i><span class="num" v-if="item_p.CheckNumber">{{item_p.CheckNumber}}</span></el-button>
                                    </el-popover>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="s_box">
                                <div class="tit">办学性质：</div>
                                <div class="box">
                                    <span class="item" :class="query.CollegeNatureIdList.length==0?'on':''" @click.prevent="CollegeNatureIdListReset()">不限</span>
                                    <span class="item" :class="query.CollegeNatureIdList.find(f=>f==item_n.Id)?'on':''" v-for="item_n in CollegeScreen.CollegeNatureList" :key="item_n.Id" @click.prevent="CollegeNatureIdListCheck(item_n)">{{item_n.Name}}</span>
                                    <div class="scopebox" v-if="ProvinceObj.EnableRecommendEducationLevel" style="margin-left:30px;">
                                        <span class="titmin">学历层次：</span>
                                        <span class="item" :class="query.EducationLevel==1?'on':''" @click.prevent="EducationLevelCheck(1)">本科</span>
                                        <span class="item" :class="query.EducationLevel==0?'on':''" @click.prevent="EducationLevelCheck(0)">专科</span>
                                    </div>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="s_box">
                                <div class="tit">实力标签：</div>
                                <div class="box">
                                    <span class="item" :class="(query.StrengthTagList.length==0?'on':'')" @click.prevent="StrengthTagListReset()">不限</span>
                                    <span class="item" :class="(query.StrengthTagList.find(f=>f==item_s.Id)?'on':'')" v-for="item_s in CollegeScreen.StrengthTagList" :key="item_s.Id" @click.prevent="StrengthTagListCheck(item_s)">{{item_s.Name}}</span>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="s_box" v-if="SelectWishWayObj.EnrollCategoryList && SelectWishWayObj.EnrollCategoryList.length>0">
                                <div class="tit">招生类别：</div>
                                <div class="box">
                                    <div class="scopebox" v-for="item_ec in SelectWishWayObj.EnrollCategoryList.filter(f=>f.EnrollCategoryId!=0)" :key="item_ec.EnrollCategoryId">
                                        <span class="titmin">{{item_ec.EnrollCategoryName}}：</span>
                                        <span class="item" :class="((!query.EnrollCategoryIdList.find(f=>f==item_ec.EnrollCategoryId)&&!query.DenyEnrollCategoryIdList.find(f=>f==item_ec.EnrollCategoryId))?'on':'')" @click.prevent="EnrollCategoryIdListReset(item_ec)">不限</span>
                                        <span class="item" :class="(query.DenyEnrollCategoryIdList.find(f=>f==item_ec.EnrollCategoryId)?'on2':'')" @click.prevent="EnrollCategoryIdListCheck(item_ec,2)">排除{{item_ec.EnrollCategoryName}}</span>
                                        <span class="item" :class="(query.EnrollCategoryIdList.find(f=>f==item_ec.EnrollCategoryId)?'on':'')" @click.prevent="EnrollCategoryIdListCheck(item_ec,1)">仅看{{item_ec.EnrollCategoryName}}</span>
                                    </div>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="s_box">
                                <div class="tit">接受专业：</div>
                                <div class="box">
                                    <span class="item" :class="query.MajorIdList.length==0?'on':''" @click.prevent="MajorTypeReset()">不限</span>
                                    <span class="type" :class="MajorScreenSelectLevel==1?'on':''" @click.prevent="MajorEducationLevelCheck(1)" v-if="ProvinceObj.EnableRecommendEducationLevel">本科<i class="iconfont" :style="{'color':(MajorScreenSelectLevel==1?'#dfdfdf':'#d06b00'),'margin-left':'3px'}">&#xe661;</i></span>
                                    <span class="type" :class="MajorScreenSelectLevel==0?'on':''" @click.prevent="MajorEducationLevelCheck(0)" v-if="ProvinceObj.EnableRecommendEducationLevel">专科<i class="iconfont" :style="{'color':(MajorScreenSelectLevel==0?'#dfdfdf':'#d06b00'),'margin-left':'3px'}">&#xe617;</i></span>
                                    <div class="clear" v-if="ProvinceObj.EnableRecommendEducationLevel"></div>
                                    <el-popover v-for="major in MajorTypeData" :key="major.Id" trigger="hover" :open-delay="50" @after-enter="ThreeMajorLayerShow(major.SubList[0].Id,major.SubList[0].SubList)" @hide="ThreeMajorLayerHide" placement="bottom" width="300" popper-class="search_major_popover">
                                        <div class="search_majorbox" :style="MajorCheckListStyle">
                                            <el-scrollbar wrap-class="scrollbar-wrapper" :style="MajorCheckListStyle" style="width:50%;">
                                                <div class="citem" :class="query.MajorIdList.find(f=>f==item1.Id)?'on':''" v-for="item1 in major.SubList" :key="item1.Id" @click.prevent="MajorTypeCheck(item1)" @mouseenter="ThreeMajorLayerShow(item1.Id,item1.SubList)">
                                                    <i class="iconfont chck">&#xe68a;</i>
                                                    <span class="mname" :class="MajorTypeHover==item1.Id?'on':''">{{item1.Name}}<span class="num" v-if="item1.CheckNumber">{{item1.CheckNumber}}</span></span>
                                                    <i class="el-icon-arrow-right three" v-if="item1.SubList"></i>
                                                </div>
                                            </el-scrollbar>
                                            <div class="three_major_box" v-if="ThreeMajorShow">
                                                <el-scrollbar wrap-class="scrollbar-wrapper" :style="MajorCheckListStyle">
                                                    <div class="citem" :class="query.MajorIdList.find(f=>f==item3.Id)?'on':''" v-for="item3 in ThreeMajorData" :key="item3.Id" @click.prevent="MajorTypeCheck(item3)">
                                                        <i class="iconfont chck">&#xe68a;</i>
                                                        <span class="mname">{{item3.Name}}</span>
                                                    </div>
                                                </el-scrollbar>
                                            </div>
                                        </div>
                                        <el-button slot="reference">{{major.Name}}<i class="el-icon-arrow-down"></i><span class="num" v-if="major.CheckNumber">{{major.CheckNumber}}</span></el-button>
                                    </el-popover>
                                    <div class="scopebox" style="margin-left:20px;">
                                        <span class="titmin">快速查找：</span>
                                        <el-select size="small" v-model="MajorMultipleSearchValue" :remote-method="MajorMultipleSearchMethod" @change="MajorMultipleSearchChange" multiple filterable remote reserve-keyword placeholder="输入关键词" style="width:170px;">
                                            <el-option v-for="item_msv in MajorMultipleSearchData" :key="item_msv.value" :value="item_msv.value">{{item_msv.label}}<i class="iconfont" v-if="query.MajorIdList.find(f=>f==item_msv.value)" style="color:rgba(var(--themecolor), 0.7);font-size:16px;margin-left:10px;">&#xe68a;</i></el-option>
                                        </el-select>
                                    </div>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="s_box" style="margin-bottom:10px;">
                                <div class="tit" style="margin-top:9px;">不接受专业：</div>
                                <div class="box">
                                    <el-cascader v-model="query.DenyMajorIdList" @change="DenyMajorChange" :options="DenyMajorData" :props="{ multiple: true,expandTrigger:'hover',emitPath:false }" size="small" :show-all-levels="false" clearable filterable style="width:calc(100% - 15px);margin-left:5px;"></el-cascader>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="s_box">
                                <div class="tit" :style="{'margin-top':(SelectWishWayObj.WishWay == 1?'8px':'11px')}">其他设置：</div>
                                <div class="box">
                                    <div class="scopebox">
                                        <span class="titmin">计划人数：</span>
                                        <span class="ltxt" style="margin-left:0px;margin-right:10px;">≥</span>
                                        <el-input v-model="query.PlanPersonsMin" size="small" maxlength="5" @blur="GetAutoGroupStat()" onkeyup="this.value=this.value.replace(/\D|^/g,'')"></el-input>
                                        <span class="ltxt">人</span>
                                    </div>
                                    <div class="scopebox">
                                        <span class="titmin">学费区间：</span>
                                        <el-input v-model="query.LearningCostBegin" size="small" maxlength="8" @blur="GetAutoGroupStat()" onkeyup="this.value=this.value.replace(/\D|^/g,'')"></el-input>
                                        -
                                        <el-input v-model="query.LearningCostEnd" size="small" maxlength="8" @blur="GetAutoGroupStat()" onkeyup="this.value=this.value.replace(/\D|^0/g,'')"></el-input>
                                        <span class="ltxt">元</span><span class="ltxt">（例：0-5000 元）</span>
                                    </div>
                                    <div class="scopebox" v-if="SelectWishWayObj.WishWay == 1">
                                        <span class="titmin">包含专业数：</span>
                                        <span class="ltxt" style="margin-left:0px;margin-right:10px;">≤</span>
                                        <el-input v-model="query.MajorCount" size="small" maxlength="3" @blur="GetAutoGroupStat()" onkeyup="this.value=this.value.replace(/\D|^0/g,'')"></el-input>
                                        <span class="ltxt">个</span>
                                    </div>
                                    <div class="scopebox" v-if="SelectWishWayObj.WishWay == 1">
                                        <span class="titmin">纯净度：</span>
                                        <span class="ltxt" style="margin-left:0px;margin-right:10px;">≥</span>
                                        <el-input v-model="query.GroupPureness" size="small" maxlength="3" @blur="PurenessBlur()" onkeyup="this.value=this.value.replace(/\D|^0/g,'')"></el-input>
                                        <span class="ltxt">%</span>
                                    </div>
                                    <div class="scopebox">
                                        <span class="titmin">推荐范围：</span>
                                        <div class="slider">
                                            <el-slider class="range_slider" @change="ReportRangeChange" v-model="ReportRangeValue" range :min="ScoreLimitMin" :max="ScoreLimitMax"> </el-slider>
                                        </div>
                                    </div>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="s_box">
                                <div class="tit" style="margin-top:8px;">推荐设置：</div>
                                <div class="box">
                                    <div class="cwbmark">按冲稳保比例加入志愿表（{{User.Year}}年 • {{User.ProvinceName}} • {{SelectRecommendBatch.BatchName}}：志愿填报数量为{{SelectWishWayObj.WishCount}}个）</div>
                                    <div class="cwbbox">
                                        <span class="cwb c">冲</span>
                                        <el-input v-model="SubmitGroupStatData.Group1" @blur="GroupStatChange()" size="small" maxlength="3" onkeyup="this.value=this.value.replace(/\D|^/g,'')"></el-input>
                                        <span class="cwb w">稳</span>
                                        <el-input v-model="SubmitGroupStatData.Group2" @blur="GroupStatChange()" size="small" maxlength="3" onkeyup="this.value=this.value.replace(/\D|^/g,'')"></el-input>
                                        <span class="cwb b">保</span>
                                        <el-input v-model="SubmitGroupStatData.Group3" @blur="GroupStatChange()" size="small" maxlength="3" onkeyup="this.value=this.value.replace(/\D|^/g,'')"></el-input>
                                        <span style="color:red;font-size:12px;">{{GetIsCount()}}</span>
                                    </div>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="clear" style="height:50px;"></div>
                        </el-scrollbar>
                    </div>
                    <!-- 底部按钮 -->
                    <div class="btnbox">
                        <div class="lbtnbox">
                            <!-- <i class="el-icon-tickets"></i> -->
                            <img src="../../assets/images/ai-tianxie.png" alt="" />
                            <span class="tjstat">根据您选择的偏好，AI为您推荐的志愿数量为：
                                <span class="tjop" v-for="(itemas,indexas) in AutoGroupStatData" :key="indexas"><span class="line" v-if="indexas!=0"></span>{{itemas.GroupShortName}}<span class="num">{{itemas.Count}}</span>个</span>
                            </span>
                            <div class="clear"></div>
                        </div>
                        <div class="rbtnbox">
                            <div class="btn b1" @click.prevent="LayerShow = false">取消</div>
                            <div class="btn b1" @click.prevent="ResetLikeData()">重置</div>
                            <div class="btn b1" @click.prevent="LayerTestShow()">AI智能助手</div>
                            <div class="btn b2" @click.prevent="LikeSetSubmit()">生成志愿</div>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <!--分析完成-->
                    <div class="analysislayer" v-if="AnalysisSuccessShow">
                        <div class="analysisbox">
                            <div class="thinking complete">
                                <div class="txt">AI分析已完成</div>
                                <div class="asico iconfont success">&#xe607;</div>
                                <div class="content">系统已为您筛选出适合您的条件</div>
                                <div class="time"><span class="t">{{SuccessTime}}</span> s 后自动关闭提示</div>
                                <div class="guanbi" @click.prevent="AnalysisSuccessColose()">手动关闭</div>
                                <div class="clear"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 志愿表弹层 -->
            <div class="wish_table_layer">
                <div class="top_fixed">
                    <div class="info">
                        <span class="user-name" :title="UserName">{{UserName}} </span>
                        <span class="yname">{{User.ProvinceName}}</span>
                        <span class="exam">
                            <span>成绩：{{User.FinalScore?User.FinalScore:User.Score}} 分</span>
                            <span class="rank">
                                <span v-if="RecommendBatch.Rank">
                                    {{ `位次: ${RecommendBatch.Rank||'-'}` }}
                                </span>
                                <span v-else-if="RecommendBatch.RankHigh || RecommendBatch.RankLow">
                                    {{ `位次：${RecommendBatch.RankHigh} - ${RecommendBatch.RankLow}` }}
                                </span>
                            </span>
                            <span v-if="User.SubjectType==1||User.SubjectType==2">
                                <span class="area">{{User.SubjectType==1?'物理':'历史'}},</span>
                                <span v-if="User.SubjectList" class="area">{{User.SubjectList.join(',')}}</span>
                            </span>
                            <span v-else-if="User.SubjectType==3||User.SubjectType==4">
                                <span class="area">{{User.SubjectType==3?'理科':'文科'}}</span>
                            </span>
                            <span v-else>
                                <span v-if="User.SubjectList" class="area">{{User.SubjectList.join(',')}}</span>
                            </span>
                            <span>批次：{{SelectRecommendBatch.BatchName}}</span>
                            <span>等效分</span>
                            <span v-for="(yearItem, yearIndex) in tempScoreEqual" :key="String(yearItem+yearIndex)">{{ yearItem+'年:'+SelectRecommendBatch.ScoreEqual[yearItem]+'分' }}</span>
                        </span>
                    </div>
                </div>
                <!-- 信息区域 -->
                <div class="wish_table">
                    <div class="wish_box">
                        <div class="mark-tips">
                            <span>注：以下志愿表为模拟填报志愿表，正式填报请登录省考试院指定填报网站</span>
                            <span>申明：使用当年招生计划和参考历年录取数据的志愿模拟填报平台，参考数据均来自省考试院，正式填报过程中如遇到数据错误，请参阅省考试院发布的相关招生计划书籍</span>
                        </div>
                        <div class="userbox">
                            <div class="type">
                                <span class="vip"><i class="iconfont">&#xe6ba;</i>{{User.wishCategory === 1?'位点法':'位次法'}}</span>
                                <span class="tname">志愿表</span>
                                <span class="yname">{{User.Year}}年 {{User.ProvinceName}} 高考志愿模拟填报</span>
                            </div>
                            <div class="bott">
                                <span @click.prevent="ToWishList()" style="background-color:#ddd;color:#777;"><i class="el-icon-arrow-left"></i>返回</span>
                                <span @click.prevent="SetLike()"><i class="el-icon-edit"></i>设置偏好</span>
                                <span @click.prevent="WishEdit"><i class="el-icon-edit"></i>修改</span>
                                <span @click.prevent="WishSave"><i class="el-icon-document-checked"></i>保存</span>
                            </div>
                        </div>
                        <div class="theadtitle">
                            <span v-if="SelectWishWayObj.WishWay == 1" class="txt">
                                您填报的志愿数量为： 院校总数 <b>{{ReportCheckData.length}}</b> 个，专业总数 <b>{{allMajorNumber}}</b> 个
                            </span>
                            <span v-else class="txt">
                                您填报的志愿数量为: <b>{{ReportCheckData.length}}</b> 个
                            </span>
                        </div>
                    </div>
                </div>
                <!-- 志愿列表（院校+专业） -->
                <div class="wish_t_h" v-if="CollegeOrMajorGroupId!=2">
                    <div class="wish_t_fixed">
                        <div class="wish_head">
                            <div class="htable">
                                <div class="head">
                                    <div class="td">序号</div>
                                    <div class="td">院校</div>
                                    <div class="td">排序</div>
                                    <div class="td">专业</div>
                                    <div class="td">{{SelectRecommendBatch.PlanYear}} 招生计划</div>
                                    <div v-if="SelectRecommendBatch.YearList" class="td">
                                        <div class="t">历年录取</div>
                                        <div class="year">
                                            <div class="y">{{SelectRecommendBatch.YearList[0]}}年</div>
                                            <div class="y">{{SelectRecommendBatch.YearList[1]}}年</div>
                                            <div class="y">{{SelectRecommendBatch.YearList[2]}}年</div>
                                        </div>
                                    </div>
                                    <div class="clear"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="wish_t_l" v-if="CollegeOrMajorGroupId==1">
                    <div class="wish_t_m">
                        <div class="wtable">
                            <div class="table">
                                <table cellspacing="0" style="width:100%;" id="WishSortTable">
                                    <tr v-for="(item, index) in ReportCheckData" :key="item.RecommendCollegeId">
                                        <td>
                                            <i class="el-icon-top" title="向上排序" @click.prevent="CollegeWishSortUp(item, index)"></i>
                                            <span class="num" title="修改排序" @click.prevent="UpdateSort(index+1, index)">{{ ProvinceObj.IsNewExam?index+1:ZMStr(index)}}</span>
                                            <i class="el-icon-bottom" title="向下排序" @click.prevent="CollegeWishSortDown(item, index)"></i>
                                            <i class="el-icon-delete" title="移除院校及专业" @click.prevent="CollegeWishRemove(item, index)"></i>
                                        </td>
                                        <td class="move">
                                            <span class="delete-status" v-show="item.deleteStatusCollege"><i class="el-icon-warning"></i>远程数据中心已删除该条数据</span>
                                            <!-- <div class="toggle" @click.stop="toggleText(item)">切换 <i class="el-icon-document"></i></div> -->
                                            <!-- <div class="replace" @click.stop="addMajor(item, index)">专业<i class="el-icon-plus replace-icon"></i></div> -->
                                            <div class="c_name">
                                                <span class="Group-name" :class="getGroupColor(item.RecommendGroupName)">{{item.RecommendGroupName}}</span>

                                                <span class="click-name" @click.stop="collegeDetail(item)">{{item.CollegeName}}</span>
                                                
                                                
                                                <span v-show="item.GroupCode">[{{ item.GroupCode }}]</span>
                                                <span v-show="ProvinceObj.EnableRecommendEducationLevel" class="level">({{item.EducationLevel==1?'本科':'专科'}})</span>
                                                <span v-show="item.MajorAdmissionRule" class="tips-words" :style="{'color':(item.MajorAdmissionRule=='专业优先'?'#f22e2e':'#666')}">{{item.MajorAdmissionRule}}</span>
                                            </div>
                                            <span class="score" v-if="User.wishCategory===1">预测分：{{item.PredictScore?item.PredictScore+'分':'-'}}<span class="isadjuststr">{{item.IsAdjust?'服从调剂':'不服从调剂'}}</span></span>
                                            <span class="score" v-else>录取概率：{{item.AdmissionProbability?item.AdmissionProbability+'%':'-'}}<span class="isadjuststr">{{item.IsAdjust?'服从调剂':'不服从调剂'}}</span></span>

                                            <div v-if="item.showText">
                                                <span v-show="item.CollegeRankNum" class="tips-words">{{item.CollegeRankNum+'['+item.CollegeRankCategoryName+']'}}</span>
                                                <div class="s_txt">
                                                    <div class="tips-words">
                                                        <span v-show="item.PlanPersons">计划人数：{{ item.PlanPersons }}</span>
                                                        <span v-show="item.SubjectsCondition">{{ item.SubjectsCondition }}</span>
                                                    </div>
                                                    <span>代码：{{item.CollegeCode}}</span>
                                                    <span v-show="item.GroupCode">专业组代码：{{ item.GroupCode }}</span>
                                                    <div class="tips-words">
                                                        <span v-show="item.PostgraduateRate">读研率：{{ item.PostgraduateRate }}%</span>
                                                        <span v-show="item.PostgraduateRecommendationRate">保研率：{{ item.PostgraduateRecommendationRate }}%</span>
                                                    </div>
                                                    <div class="tips-words">
                                                        <span v-show="item.RecommendMajorCount">包含专业数：{{ item.RecommendMajorCount }}</span>
                                                        <span v-show="item.GroupPureness"> 专业组纯净度：{{ item.GroupPureness }}%</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="add-major" @click="addMajor(item, index)">添加专业 <i class="el-icon-plus"></i></div>
                                        </td>
                                        <td>
                                            <table cellspacing="0" style="width:100%;">
                                                <tr v-for="(majorItem, majorIndex) in item.SelectMajor" :key="majorItem.RecommendMajorId">
                                                    <td>
                                                        <i class="el-icon-top" title="向上排序" @click.prevent="collegeMajorSortUp(index, majorIndex)"></i>
                                                        <span class="num" style="border:none;cursor:default;color:#666;">{{ (majorIndex+1)}}</span>
                                                        <i class="el-icon-bottom" title="向下排序" @click.prevent="collegeMajorSortDown(index, majorIndex)"></i>
                                                        <i class="el-icon-delete" title="移除专业" @click.prevent="collegeMajorRemove(index, majorIndex)"></i>
                                                    </td>
                                                    <td class="move">
                                                        <span class="delete-status college-major" v-show="majorItem.deleteStatusCollegeMajor"><i class="el-icon-warning"></i>远程数据中心已删除该条数据</span>
                                                        <!-- <div class="toggle" @click.stop="toggleText(majorItem)">切换 <i class="el-icon-document"></i></div> -->
                                                        <div class="replace" @click.stop="replaceMajor(item, index, majorIndex)">替换<i class="el-icon-sort replace-icon"></i></div>
                                                        <div class="major">
                                                            <div class="name">
                                                                <span class="major-name" @click.stop="majorDetail(majorItem)">{{majorItem.MajorName}}</span>
                                                                <el-popover v-if="majorItem.MajorLimitList" placement="top" width="400" trigger="hover" class="zyxb" popper-class="zyxb-mark">
                                                                    <div style="color:#d91616;font-size:12px;">温馨提示：专业限报仅作参考使用，具体详情请参考院校招生章程或拨打院校招办电话咨询</div>
                                                                    <span class="xbitem" v-for="(xbitem,xbindex) in majorItem.MajorLimitList" :key="xbindex">{{xbitem.LimitStr}}</span>
                                                                    <el-button slot="reference">专业限报<i class="el-icon-d-arrow-right"></i></el-button>
                                                                </el-popover>
                                                            </div>
                                                            <div v-if="majorItem.showText" class="mx">
                                                                {{majorItem.MajorRemark}}
                                                                <el-tag class="tag" v-if="majorItem.MajorEnrollCategories" type="danger" size="mini">{{ majorItem.MajorEnrollCategories }}</el-tag>
                                                                <span v-show="majorItem.IsPostgraduateMaster" class="sbtips">硕</span>
                                                                <span v-show="majorItem.IsPostgraduateDoctoral" class="sbtips">博</span>
                                                            </div>
                                                            <div class="mx">
                                                                <span>代码：{{majorItem.MajorCode}}</span>
                                                                <span v-if="User.wishCategory===1">预测分：{{majorItem.PredictScore?majorItem.PredictScore+'分':'-'}}</span>
                                                                <span v-else>录取概率：{{majorItem.AdmissionProbability?majorItem.AdmissionProbability+'%':'-'}}</span>

                                                                <div v-if="majorItem.showText" class="tips-words">
                                                                    <span v-show="majorItem.PostgraduateRate">读研率：{{ majorItem.PostgraduateRate }}%</span>
                                                                    <span v-show="majorItem.PostgraduateRecommendationRate">保研率：{{ majorItem.PostgraduateRecommendationRate }}%</span>
                                                                    <span v-show="majorItem.LearnSubjectEvaluateLevel" class="evaluate">学科评估：{{majorItem.LearnSubjectEvaluateLevel}}</span>
                                                                    <span v-show="majorItem.MajorRankNum||majorItem.MajorRankLevel||majorItem.MajorStrengthTags">
                                                                        专业实力：{{majorItem.MajorRankNum}}{{(majorItem.MajorRankLevel&&majorItem.MajorRankNum)?(' / '+majorItem.MajorRankLevel):majorItem.MajorRankLevel}}
                                                                        <span class="question-text" v-if="majorItem.MajorRankNum||majorItem.MajorRankLevel">
                                                                            <img class="icon" src="@/assets/wish/question.svg" alt="">
                                                                            <span class="text">
                                                                                “软科中国大学专业排名”计算给出每个专业点的综合评级以及在各个指标类别的评级，规则如下：<br/>
                                                                                综合评级规则：共分为6档，专业综合排名位次为前2%或前2名的为A+级，2% - 10%的为A级，10% - 30%的为B+级，30% - 50%的为B级，50% - 70%的为C级（不发布）, 70%以后的为D级（不发布）。
                                                                            </span>
                                                                        </span>
                                                                        {{majorItem.MajorStrengthTags}}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div v-show="majorItem.PlanPersons" class="person"><span>{{majorItem.PlanPersons}}</span> 人</div>
                                                        <div>
                                                            <span v-show="majorItem.LearningYears" class="md">{{majorItem.LearningYears}}年</span>
                                                            <span v-show="majorItem.LearningCost" class="md"> ￥{{majorItem.LearningCost}}</span>
                                                        </div>
                                                        <div v-show="majorItem.SubjectsCondition" class="md">{{majorItem.SubjectsCondition}}</div>
                                                    </td>
                                                    <td style="position:relative;">
                                                        <div v-if="MajorLimitWarning(majorItem.MajorLimitList).length>0" class="MajorLimitItemStyle" :id="'YZMajorLimitId_'+index+'_'+majorIndex">
                                                            <div class="mlclose el-icon-d-arrow-right" @click="MajorLimitItemColseOpen('YZMajorLimitId_'+index+'_'+majorIndex)"></div>
                                                            <div class="MajorLimitItemCon">
                                                                <div class="mltips">温馨提示：专业限报仅作参考使用，具体详情请参考院校招生章程或拨打院校招办电话咨询</div>
                                                                <div class="mltitle">根据您的个人信息对比，您有以下选项可能不符合该专业报考要求：</div>
                                                                <span class="mlitem" v-for="(mlitem,mlindex) in MajorLimitWarning(majorItem.MajorLimitList)" :key="mlindex">{{mlitem}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="itemarr">
                                                            <div class="ls">
                                                                <span style="position:relative;"><span class="zhengji" v-if="majorItem.IsHasZJOfYear1"><span style="position:relative;">征<span class="zjtxt">{{SelectRecommendBatch.YearList[0]}}年有征集</span></span></span>最低分 / 位次：{{majorItem.ScoreLowOfYear1}} / <span :style="{'display':'inline-block','color':(parseInt(RecommendBatch.RankLow)<parseInt(majorItem.RankLowOfYear1)?'green':'red')}">{{majorItem.RankLowOfYear1}}</span></span>
                                                                <span v-if="majorItem.showText">平均分 / 位次：{{majorItem.ScoreAvgOfYear1}} / <span :style="{'display':'inline-block','color':(parseInt(RecommendBatch.RankLow)<parseInt(majorItem.RankAvgOfYear1)?'green':'red')}">{{majorItem.RankAvgOfYear1}}</span></span>
                                                                <span v-if="majorItem.showText">录取人数：{{majorItem.PersonsOfYear1}}</span>
                                                                <span v-if="majorItem.showText" class="tips">
                                                                    <span class="tips-text">
                                                                        <img class="icon" src="@/assets/wish/question.svg" alt="" style="left:-16px;">
                                                                        <span class="show-text">等效分差根据当前考生成绩通过历年一分一段换算成历年的等效成绩与最低录取分数的差值，换算后的等效分差可以更精确的与历年分数进行比较</span>
                                                                    </span>
                                                                    <span>等效分差 / 位次差：{{ majorItem.PersonalScoreDiffOfYear1 }} / {{ majorItem.RankLowDiffOfYear1 }}</span>
                                                                </span>
                                                            </div>
                                                            <div class="ls">
                                                                <span style="position:relative;"><span class="zhengji" v-if="majorItem.IsHasZJOfYear2"><span style="position:relative;">征<span class="zjtxt">{{SelectRecommendBatch.YearList[1]}}年有征集</span></span></span>最低分 / 位次：{{majorItem.ScoreLowOfYear2}} / <span :style="{'display':'inline-block','color':(parseInt(RecommendBatch.RankLow)<parseInt(majorItem.RankLowOfYear2)?'green':'red')}">{{majorItem.RankLowOfYear2}}</span></span>
                                                                <span v-if="majorItem.showText">平均分 / 位次：{{majorItem.ScoreAvgOfYear2}} / <span :style="{'display':'inline-block','color':(parseInt(RecommendBatch.RankLow)<parseInt(majorItem.RankAvgOfYear2)?'green':'red')}">{{majorItem.RankAvgOfYear2}}</span></span>
                                                                <span v-if="majorItem.showText">录取人数：{{majorItem.PersonsOfYear2}}</span>
                                                                <span v-if="majorItem.showText" class="tips">
                                                                    <span class="tips-text">
                                                                        <img class="icon" src="@/assets/wish/question.svg" alt="" style="left:-16px;">
                                                                        <span class="show-text">等效分差根据当前考生成绩通过历年一分一段换算成历年的等效成绩与最低录取分数的差值，换算后的等效分差可以更精确的与历年分数进行比较</span>
                                                                    </span>
                                                                    <span>等效分差 / 位次差：{{ majorItem.PersonalScoreDiffOfYear2 }} / {{ majorItem.RankLowDiffOfYear2 }}</span>
                                                                </span>
                                                            </div>
                                                            <div class="ls">
                                                                <span style="position:relative;"><span class="zhengji" v-if="majorItem.IsHasZJOfYear3"><span style="position:relative;">征<span class="zjtxt">{{SelectRecommendBatch.YearList[2]}}年有征集</span></span></span>最低分 / 位次：{{majorItem.ScoreLowOfYear3}} / <span :style="{'display':'inline-block','color':(parseInt(RecommendBatch.RankLow)<parseInt(majorItem.RankLowOfYear3)?'green':'red')}">{{majorItem.RankLowOfYear3}}</span></span>
                                                                <span v-if="majorItem.showText">平均分 / 位次：{{majorItem.ScoreAvgOfYear3}} / <span :style="{'display':'inline-block','color':(parseInt(RecommendBatch.RankLow)<parseInt(majorItem.RankAvgOfYear3)?'green':'red')}">{{majorItem.RankAvgOfYear3}}</span></span>
                                                                <span v-if="majorItem.showText">录取人数：{{majorItem.PersonsOfYear3}}</span>
                                                                <span v-if="majorItem.showText" class="tips">
                                                                    <span class="tips-text">
                                                                        <img class="icon" src="@/assets/wish/question.svg" alt="" style="left:-16px;">
                                                                        <span class="show-text">等效分差根据当前考生成绩通过历年一分一段换算成历年的等效成绩与最低录取分数的差值，换算后的等效分差可以更精确的与历年分数进行比较</span>
                                                                    </span>
                                                                    <span>等效分差 / 位次差：{{ majorItem.PersonalScoreDiffOfYear3 }} / {{ majorItem.RankLowDiffOfYear3 }}</span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                                <div class="nowish" v-show="false">暂无数据！</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 志愿列表（专业+院校） -->
                <div class="wish_t_h" v-if="CollegeOrMajorGroupId==2">
                    <div class="wish_t_fixed">
                        <div class="wish_head">
                            <div class="htable">
                                <div class="head majorgroup">
                                    <div class="td">序号</div>
                                    <div class="td">专业</div>
                                    <div class="td">院校</div>
                                    <div class="td">{{SelectRecommendBatch.PlanYear}} 招生计划</div>
                                    <div v-if="SelectRecommendBatch.YearList" class="td">
                                        <div class="t">历年录取</div>
                                        <div class="year">
                                            <div class="y">{{SelectRecommendBatch.YearList[0]}}年</div>
                                            <div class="y">{{SelectRecommendBatch.YearList[1]}}年</div>
                                            <div class="y">{{SelectRecommendBatch.YearList[2]}}年</div>
                                        </div>
                                    </div>
                                    <div class="clear"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="wish_t_l" v-if="CollegeOrMajorGroupId==2">
                    <div class="wish_t_m">
                        <div class="wtable">
                            <div class="table majorgroup">
                                <table cellspacing="0" style="width:100%;" id="WishSortTable">
                                    <tr v-for="(item, index) in ReportCheckData" :key="item.RecommendMajorId">
                                        <td>
                                            <i class="el-icon-top" title="向上排序" @click.prevent="WishMajorSortUp(item, index)"></i>
                                            <span class="num" title="修改排序" @click.prevent="UpdateSort(index+1, index)">{{index+1}}</span>
                                            <i class="el-icon-bottom" title="向下排序" @click.prevent="WishMajorSortDown(item, index)"></i>
                                            <i class="el-icon-delete" title="移除院校及专业" @click.prevent="WishMajorRemove(item, index)"></i>
                                        </td>
                                        <td class="move">
                                            <div class="major">
                                                <div class="name">
                                                    <span class="Group-name" :class="getGroupColor(item.RecommendGroupName)">{{item.RecommendGroupName}}</span>
                                                    <span class="major-name" @click.stop="majorDetail(item)">{{item.MajorName}}</span>
                                                    <el-popover v-if="item.MajorLimitList" placement="top" width="400" trigger="hover" class="zyxb" popper-class="zyxb-mark">
                                                        <div style="color:#d91616;font-size:12px;">温馨提示：专业限报仅作参考使用，具体详情请参考院校招生章程或拨打院校招办电话咨询</div>
                                                        <span class="xbitem" v-for="(xbitem,xbindex) in item.MajorLimitList" :key="xbindex">{{xbitem.LimitStr}}</span>
                                                        <el-button slot="reference">专业限报<i class="el-icon-d-arrow-right"></i></el-button>
                                                    </el-popover>
                                                </div>
                                                <span class="score" v-if="User.wishCategory===1">预测分：{{item.PredictScore?item.PredictScore+'分':'-'}}</span>
                                                <span class="score" v-else>录取概率：{{item.AdmissionProbability?item.AdmissionProbability+'%':'-'}}</span>

                                                <div v-if="item.showText" class="mx">
                                                    {{item.MajorRemark}}
                                                    <el-tag class="tag" v-if="item.MajorEnrollCategories" type="danger" size="mini">{{ item.MajorEnrollCategories }}</el-tag>
                                                    <span v-show="item.IsPostgraduateMaster" class="sbtips">硕</span>
                                                    <span v-show="item.IsPostgraduateDoctoral" class="sbtips">博</span>
                                                </div>
                                                <div class="mx"><span>代码：{{item.MajorCode}}</span>
                                                    <div v-if="item.showText" class="tips-words">
                                                        <span v-show="item.PostgraduateRate">读研率：{{ item.PostgraduateRate }}%</span>
                                                        <span v-show="item.PostgraduateRecommendationRate">保研率：{{ item.PostgraduateRecommendationRate }}%</span>
                                                        <span v-show="item.LearnSubjectEvaluateLevel" class="evaluate">学科评估：{{item.LearnSubjectEvaluateLevel}}</span>
                                                        <span v-show="item.MajorRankNum||item.MajorRankLevel||item.MajorStrengthTags">
                                                            专业实力：{{item.MajorRankNum}}{{(item.MajorRankLevel&&item.MajorRankNum)?(' / '+item.MajorRankLevel):item.MajorRankLevel}}
                                                            <span class="question-text" v-if="item.MajorRankNum||item.MajorRankLevel">
                                                                <img class="icon" src="@/assets/wish/question.svg" alt="">
                                                                <span class="text">
                                                                    “软科中国大学专业排名”计算给出每个专业点的综合评级以及在各个指标类别的评级，规则如下：<br/>
                                                                    综合评级规则：共分为6档，专业综合排名位次为前2%或前2名的为A+级，2% - 10%的为A级，10% - 30%的为B+级，30% - 50%的为B级，50% - 70%的为C级（不发布）, 70%以后的为D级（不发布）。
                                                                </span>
                                                            </span>
                                                            {{item.MajorStrengthTags}}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="move">
                                            <div class="c_name">
                                                <span class="click-name" @click.stop="collegeDetail(item)">
                                                    {{item.CollegeName||(item.FromCollege&&item.FromCollege.CollegeName)||''}}
                                                </span>
                                                <span v-show="ProvinceObj.EnableRecommendEducationLevel" class="level">({{item.EducationLevel==1?'本科':'专科'}})</span>
                                            </div>

                                            <span v-show="item.CollegeRankNum" class="tips-words">{{item.CollegeRankNum+'['+item.CollegeRankCategoryName+']'}}</span>
                                            <div class="s_txt">
                                                <span>代码：{{item.CollegeCode||(item.FromCollege&&item.FromCollege.CollegeCode)||''}}</span>
                                                <span v-if="item.showText" class="types">{{handleNature(item)}}</span>
                                                <span v-if="item.showText" class="tipss" :title="item.CollegeStrengthTags||(item.FromCollege&&item.FromCollege.CollegeStrengthTags)||''">
                                                    <span v-for="tagItem in handleTag(item)" :key="tagItem">{{tagItem}}</span>
                                                </span>
                                            </div>
                                        </td>
                                        <td class="move">
                                            <div v-show="item.PlanPersons" class="person"><span>{{item.PlanPersons}}</span> 人</div>
                                            <div>
                                                <span v-show="item.LearningYears" class="md">{{item.LearningYears}}年</span>
                                                <span v-show="item.LearningCost" class="md"> ￥{{item.LearningCost}}</span>
                                            </div>
                                            <div v-show="item.SubjectsCondition" class="md">{{item.SubjectsCondition}}</div>
                                        </td>
                                        <td class="move" style="position:relative;">
                                            <div v-if="MajorLimitWarning(item.MajorLimitList).length>0" class="MajorLimitItemStyle" :id="'ZYMajorLimitId_'+index">
                                                <div class="mlclose el-icon-d-arrow-right" @click.stop="MajorLimitItemColseOpen('ZYMajorLimitId_'+index)"></div>
                                                <div class="MajorLimitItemCon">
                                                    <div class="mltips">温馨提示：专业限报仅作参考使用，具体详情请参考院校招生章程或拨打院校招办电话咨询</div>
                                                    <div class="mltitle">根据您的个人信息对比，您有以下选项可能不符合该专业报考要求：</div>
                                                    <span class="mlitem" v-for="(mlitem,mlindex) in MajorLimitWarning(item.MajorLimitList)" :key="mlindex">{{mlitem}}</span>
                                                </div>
                                            </div>
                                            <div class="itemarr">
                                                <div class="ls">
                                                    <span style="position:relative;"><span class="zhengji" v-if="item.IsHasZJOfYear1"><span style="position:relative;">征<span class="zjtxt">{{SelectRecommendBatch.YearList[0]}}年有征集</span></span></span>最低分 / 位次：{{item.ScoreLowOfYear1}} / <span :style="{'display':'inline-block','color':(parseInt(RecommendBatch.RankLow)<parseInt(item.RankLowOfYear1)?'green':'red')}">{{item.RankLowOfYear1?item.RankLowOfYear1:''}}</span></span>
                                                    <span v-if="item.showText">平均分 / 位次：{{item.ScoreAvgOfYear1}} / <span :style="{'display':'inline-block','color':(parseInt(RecommendBatch.RankLow)<parseInt(item.RankAvgOfYear1)?'green':'red')}">{{item.RankAvgOfYear1?item.RankAvgOfYear1:''}}</span></span>
                                                    <span v-if="item.showText">录取人数：{{item.PersonsOfYear1}}</span>
                                                    <span v-if="item.showText" class="tips">
                                                        <span class="tips-text">
                                                            <img class="icon" src="@/assets/wish/question.svg" alt="" style="left:-16px;">
                                                            <span class="show-text">等效分差根据当前考生成绩通过历年一分一段换算成历年的等效成绩与最低录取分数的差值，换算后的等效分差可以更精确的与历年分数进行比较</span>
                                                        </span>
                                                        <span>等效分差 / 位次差：{{ item.PersonalScoreDiffOfYear1 }} / {{ item.RankLowDiffOfYear1 }}</span>
                                                    </span>
                                                </div>
                                                <div class="ls">
                                                    <span style="position:relative;"><span class="zhengji" v-if="item.IsHasZJOfYear2"><span style="position:relative;">征<span class="zjtxt">{{SelectRecommendBatch.YearList[1]}}年有征集</span></span></span>最低分 / 位次：{{item.ScoreLowOfYear2}} / <span :style="{'display':'inline-block','color':(parseInt(RecommendBatch.RankLow)<parseInt(item.RankLowOfYear2)?'green':'red')}">{{item.RankLowOfYear2?item.RankLowOfYear2:''}}</span></span>
                                                    <span v-if="item.showText">平均分 / 位次：{{item.ScoreAvgOfYear2}} / <span :style="{'display':'inline-block','color':(parseInt(RecommendBatch.RankLow)<parseInt(item.RankAvgOfYear2)?'green':'red')}">{{item.RankAvgOfYear2?item.RankAvgOfYear2:''}}</span></span>
                                                    <span v-if="item.showText">录取人数：{{item.PersonsOfYear2}}</span>
                                                    <span v-if="item.showText" class="tips">
                                                        <span class="tips-text">
                                                            <img class="icon" src="@/assets/wish/question.svg" alt="" style="left:-16px;">
                                                            <span class="show-text">等效分差根据当前考生成绩通过历年一分一段换算成历年的等效成绩与最低录取分数的差值，换算后的等效分差可以更精确的与历年分数进行比较</span>
                                                        </span>
                                                        <span>等效分差 / 位次差：{{ item.PersonalScoreDiffOfYear2 }} / {{ item.RankLowDiffOfYear2 }}</span>
                                                    </span>
                                                </div>
                                                <div class="ls">
                                                    <span style="position:relative;"><span class="zhengji" v-if="item.IsHasZJOfYear3"><span style="position:relative;">征<span class="zjtxt">{{SelectRecommendBatch.YearList[2]}}年有征集</span></span></span>最低分 / 位次：{{item.ScoreLowOfYear3}} / <span :style="{'display':'inline-block','color':(parseInt(RecommendBatch.RankLow)<parseInt(item.RankLowOfYear3)?'green':'red')}">{{item.RankLowOfYear3?item.RankLowOfYear3:''}}</span></span>
                                                    <span v-if="item.showText">平均分 / 位次：{{item.ScoreAvgOfYear3}} / <span :style="{'display':'inline-block','color':(parseInt(RecommendBatch.RankLow)<parseInt(item.RankAvgOfYear3)?'green':'red')}">{{item.RankAvgOfYear3?item.RankAvgOfYear3:''}}</span></span>
                                                    <span v-if="item.showText">录取人数：{{item.PersonsOfYear3}}</span>
                                                    <span v-if="item.showText" class="tips">
                                                        <span class="tips-text">
                                                            <img class="icon" src="@/assets/wish/question.svg" alt="" style="left:-16px;">
                                                            <span class="show-text">等效分差根据当前考生成绩通过历年一分一段换算成历年的等效成绩与最低录取分数的差值，换算后的等效分差可以更精确的与历年分数进行比较</span>
                                                        </span>
                                                        <span>等效分差 / 位次差：{{ item.PersonalScoreDiffOfYear3 }} / {{ item.RankLowDiffOfYear3 }}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                                <div class="nowish" v-show="false">暂无数据！</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- 底部 -->
        <PFooter></PFooter>
    </div>
</template>
<script>
import PHeader from "@/components/Header.vue";
import PFooter from "@/components/Footer.vue";
import API from "@/api/config";
import { getStore, setStore, removeStore } from "@/utils/utils";
export default{
    components:{
        PHeader,
        PFooter
    },
    data() {
        return{
            LoadingShow:false,
            User: {},
            LoginInfo: {},
            ProvinceObj: {}, // 省份
            RecommendBatch: {}, // 批次
            SelectRecommendBatch: {},
            SelectWishWayObj: {
                EnrollCategoryList:[]
            },
            CollegeOrMajorGroupId: 2,
            TestListData:[],
            TestListCheck:{},
            LayerShow:false,
            TestLikeImportShow:false,
            AutoGroupStatData:{},
            SubmitGroupStatData:{
                Group1:null,
                Group2:null,
                Group3:null
            },
            CollegeScreen:{},
            CollegeAreaListData:[],
            CityTotalNumber:0,
            MajorTypeData: [],
            MajorCheckListStyle:'',
            ThreeMajorShow :false,
            ThreeMajorData :[],
            MajorTypeHover:'',
            MajorMultipleSearchData:[],
            MajorMultipleSearchValue:[],
            ScoreLimitMax: 0,
            ScoreLimitMin: 0,
            ReportRangeValue:[0,0],
            MajorScreenSelectLevel: 1,
            DenyMajorData:[],
            query:{
                StudentId: "",
                RecommendKey: "",
                ScoreBegin: null,
                ScoreEnd: null,
                SubjectList: [],
                YearList: [],
                Score: null,
                Rank: null,
                ScoreEqual: {},
                CollegeAreaList: [],
                EducationLevel: null,
                CollegeNatureIdList: [],
                StrengthTagList: [],
                CollegeIdList: [],
                MajorIdList: [],
                DenyMajorIdList: [],
                EnrollCategoryIdList: [],
                DenyEnrollCategoryIdList: [],
                LearningCostBegin: null,
                LearningCostEnd: null,
                PlanPersonsMin: null,
                MajorCount: null,
                GroupPureness: null,
                WishCount: {},
                AreaData:[],
                IsFirstCityCheck:false,
                IsNewFirstCityCheck:false
            },
            ReportCheckData: [],
            tempScoreEqual: [],
            swapValue: '',
            UserName:'',
            SaveQuery: {},
            modifyObj: {
                modifyFlag: false
            },

            MajorQuery: {
                RecommendKey: '',
                RecommendCollegeId: '',
                SubjectList: [],
                YearList: [],
                ScoreEqual: [],
                WishWay: '',
                IsOrderAsc: true
            },
            IsImportTest:false,
            UserLikeData:{
                Message:"",
                MessageList:[]
            },
            TestBaseUrl: window.location.host + "/#",
            MakeTestShow:false,
            TestIframeShow:false,
            AnalysisLayerShow:false,
            AnalysisSuccessShow:false,
            SuccessTime:5,
            SuccessTimer:null,
            QuestionTipsShow:false
        }
    },
    mounted(){
        this.initial();//初始化
    },
    methods:{
        //初始化
        initial(){
            this.LoadingShow=true;//加载动画显示
            this.User = JSON.parse(getStore('studentReport'));// 获取学生高考信息
            this.LoginInfo = JSON.parse(getStore('LoginData'));// 获取学生登录信息
            let item = getStore("SelectRecommendBatch");//批次信息
            if(item){
                item=JSON.parse(item);
                this.tempScoreEqual = Object.keys(item.ScoreEqual)
                this.tempScoreEqual.sort().reverse()
                setStore("SelectRecommendBatch", item);
                this.SelectRecommendBatch = item;
                // 获取选中省份
                let province = getStore('OrgProvince')
                if (!province) {
                    this.$message.error('未获取到省份数据！')
                    return false
                }
                this.ProvinceObj = JSON.parse(province);
                this.SelectWishWayObj = this.ProvinceObj.WishWayDic[item.BatchId];
                this.CollegeOrMajorGroupId = this.SelectWishWayObj.WishWay==0?1:this.SelectWishWayObj.WishWay;
                if(this.SelectWishWayObj.EducationLevel!==0 && this.SelectWishWayObj.EducationLevel!==1) {
                    this.MajorScreenSelectLevel = 1;
                }
                else {
                    this.MajorScreenSelectLevel = this.SelectWishWayObj.EducationLevel;
                }

                // 添加/替换专业时的参数
                this.MajorQuery.RecommendKey = this.SelectRecommendBatch.RecommendKey;
                this.MajorQuery.SubjectList = this.User.SubjectList || null;
                this.MajorQuery.YearList = this.SelectRecommendBatch.YearList;
                this.MajorQuery.ScoreEqual = this.SelectRecommendBatch.ScoreEqual || null;
                this.MajorQuery.WishWay = this.SelectWishWayObj.WishWay;
                this.MajorQuery.Rank = this.RecommendBatch.Rank||this.RecommendBatch.RankLow;

                this.query.StudentId = this.LoginInfo.UserId;
                this.query.SubjectList = this.User.SubjectList;
                this.query.Score = this.User.FinalScore?this.User.FinalScore:this.User.Score;
                this.query.Rank = this.RecommendBatch.Rank||this.RecommendBatch.RankLow;
                this.query.RecommendKey = item.RecommendKey;
                this.query.YearList = item.YearList;
                this.query.ScoreEqual = item.ScoreEqual;

                // 计算分数范围
                if(this.User.wishCategory==1) {
                    let v1 = this.query.Score + this.ProvinceObj.ScoreRangeUpMax
                    let v2 = this.query.Score - this.ProvinceObj.ScoreRangeDownMax
                    this.ScoreLimitMax = v1
                    this.ScoreLimitMin = v2
                    
                    let d1 = this.query.Score + this.ProvinceObj.ScoreRangeUpDefault
                    let d2 = this.query.Score - this.ProvinceObj.ScoreRangeDownDefault
                    this.query.ScoreBegin = d2;
                    this.query.ScoreEnd = d1;
                    this.ReportRangeValue = [d2,d1];
                }
                else {
                    let t = Object.keys(this.SelectRecommendBatch.ScoreEqual)
                    if (t.length>0) {
                        t.sort().reverse()
                        let TScore = this.SelectRecommendBatch.ScoreEqual[t[0]]
                        TScore = Number(TScore)
                        
                        let v1 = TScore + this.ProvinceObj.ScoreRangeUpMax
                        let v2 = TScore - this.ProvinceObj.ScoreRangeDownMax
                        this.ScoreLimitMax = v1
                        this.ScoreLimitMin = v2

                        let d1 = TScore + this.ProvinceObj.ScoreRangeUpDefault
                        let d2 = TScore - this.ProvinceObj.ScoreRangeDownDefault
                        this.query.ScoreBegin = d2;
                        this.query.ScoreEnd = d1;
                        this.ReportRangeValue = [d2,d1];
                    }
                }
                // 获取当前学生的偏好缓存数据
                let StudentItem = getStore("LargeModelLikeData_"+this.LoginInfo.UserId);
                if(StudentItem){
                    StudentItem = JSON.parse(StudentItem);
                    this.query.CollegeAreaList= StudentItem.CollegeAreaList;
                    this.query.EducationLevel= StudentItem.EducationLevel;
                    this.query.CollegeNatureIdList= StudentItem.CollegeNatureIdList;
                    this.query.StrengthTagList= StudentItem.StrengthTagList;
                    this.query.MajorIdList= StudentItem.MajorIdList;
                    this.query.DenyMajorIdList= StudentItem.DenyMajorIdList;
                    this.query.EnrollCategoryIdList= StudentItem.EnrollCategoryIdList;
                    this.query.DenyEnrollCategoryIdList= StudentItem.DenyEnrollCategoryIdList;
                    this.query.LearningCostBegin= StudentItem.LearningCostBegin;
                    this.query.LearningCostEnd= StudentItem.LearningCostEnd;
                    this.query.PlanPersonsMin= StudentItem.PlanPersonsMin;
                    this.query.MajorCount= StudentItem.MajorCount;
                    this.query.GroupPureness= StudentItem.GroupPureness;
                    this.query.WishCount= StudentItem.WishCount;
                    this.query.AreaData =StudentItem.AreaData;
                    this.query.IsFirstCityCheck=StudentItem.IsFirstCityCheck;
                    this.query.IsNewFirstCityCheck=StudentItem.IsNewFirstCityCheck;
                }
                this.GetCollegeQueryParameter();// 获取偏好筛选条件
            }
        },
        // 获取偏好筛选条件
        GetCollegeQueryParameter(){
            API.Web.GetCollegeQueryParameter().then(res => {
                this.CollegeScreen = res.Data;
                this.CollegeScreen.CollegeAreaList.forEach(item => {
                    this.CollegeAreaListData.push({AreaType: 1,AreaId: item.ProvinceId,AreaName: item.ProvinceName,CityList:[]});
                });
                // 处理城市选中
                if(this.query.AreaData){
                    if(this.query.AreaData.length>0){
                        this.CollegeAreaListData = this.query.AreaData;
                    }
                }
                this.CityCheckNumber();//更新已选城市数量 
                this.GetMajorTreeList();//获取专业类别数据
                let st = setTimeout(()=>{
                    this.SetScoreStyleAndLimit();// 设置推荐范围dom样式、分数、提交参数
                    this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
                    this.LayerTestShow();// 显示测评弹层
                    clearTimeout(st);
                },500);
            });
        },
        // 院校地区 选择/取消
        CollegeAreaListCheck(item_p,item_c){
            this.CollegeAreaListData.forEach(item => {
                if(item.AreaId==item_p.ProvinceId){
                    let temp = item.CityList.find(f => f.AreaId === item_c.CityId);// 判断当前城市是否已选中
                    if(temp){
                        item.CityList = item.CityList.filter(f=>f.AreaId!=item_c.CityId);// 移除
                    }
                    else{
                        item.CityList.push({AreaType:2,AreaId:item_c.CityId,AreaName:item_c.CityName});// 添加
                    }
                }
            });
            this.CityCheckNumber();//更新已选城市数量
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 院校地区 省份内 全选/反选
        CollegeAreaListCheckAll(item){
            this.CollegeAreaListData.forEach(chek => {
                if(chek.AreaId==item.ProvinceId){
                    if(chek.CityList.length!=item.CityList.length){
                        chek.CityList = [];
                        item.CityList.forEach(ot => {
                            chek.CityList.push({AreaType:2,AreaId:ot.CityId,AreaName:ot.CityName});// 添加
                        });
                    }
                    else{
                        chek.CityList = [];
                    }
                }
            });
            this.CityCheckNumber();// 绑定已选城市数量及参数组装
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 院校地区 不限
        CollegeAreaListReset(){
            this.CollegeAreaListData.forEach(chek => {
                chek.CityList=[];
            });
            this.CityCheckNumber();// 绑定已选城市数量及参数组装
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 院校地区 一线城市
        FirstCityReset(){
            let AreaList = [
                {
                    ProvinceId: "16544791295722496",
                    ProvinceName: "北京",
                    CityList: [
                        {
                            CityId: "16544812353864704",
                            CityName: "北京市"
                        }
                    ]
                },
                {
                    ProvinceId: "16544791295722498",
                    ProvinceName: "上海",
                    CityList: [
                        {
                            CityId: "16544812353864706",
                            CityName: "上海市"
                        }
                    ]
                },
                {
                    ProvinceId: "16544791295722515",
                    ProvinceName: "广东",
                    CityList: [
                        {
                            CityId: "16544812353864898",
                            CityName: "广州市"
                        },
                        {
                            CityId: "16544812353864900",
                            CityName: "深圳市"
                        }
                    ]
                }
            ];
            AreaList.forEach(area => {
                // 添加一线城市
                if(!this.query.IsFirstCityCheck){
                    // 判断是否选中省份
                    let obj1 = this.query.CollegeAreaList.find(f=>f.AreaId==area.ProvinceId);
                    if(!obj1){
                        // 循环一线城市
                        area.CityList.forEach(city => {
                            // 判断是否选中城市
                            let obj2 = this.query.CollegeAreaList.find(f=>f.AreaId==city.CityId);
                            if(!obj2){
                                this.CollegeAreaListData.forEach(item => {
                                    if(item.AreaId==area.ProvinceId){
                                        item.CityList.push({AreaType:2,AreaId:city.CityId,AreaName:city.CityName});// 添加
                                    }
                                });
                            }
                        });
                    }
                }
                // 移除一线城市
                else{
                    // 循环一线城市
                    area.CityList.forEach(city => {
                        this.CollegeAreaListData.forEach(item => {
                            if(item.AreaId==area.ProvinceId){
                                item.CityList = item.CityList.filter(f=>f.AreaId!=city.CityId);// 移除
                            }
                        });
                    });
                }
            });
            this.CityCheckNumber();//更新已选城市数量
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 院校地区 新一线城市
        NewFirstCityReset(){
            let AreaList = [
                {
                    ProvinceId: "16544791295722518",
                    ProvinceName: "四川",
                    CityList: [
                        {
                            CityId: "16544812353864937",
                            CityName: "成都市"
                        }
                    ]
                },
                {
                    ProvinceId: "16544791295722507",
                    ProvinceName: "浙江",
                    CityList: [
                        {
                            CityId: "16544812353864791",
                            CityName: "杭州市"
                        },
                        {
                            CityId: "16544812353864792",
                            CityName: "宁波市"
                        }
                    ]
                },
                {
                    ProvinceId: "16544791295722499",
                    ProvinceName: "重庆",
                    CityList: [
                        {
                            CityId: "16544812353864707",
                            CityName: "重庆市"
                        }
                    ]
                },
                {
                    ProvinceId: "16544791295722513",
                    ProvinceName: "湖北",
                    CityList: [
                        {
                            CityId: "16544812353864871",
                            CityName: "武汉市"
                        }
                    ]
                },
                {
                    ProvinceId: "16544791295722506",
                    ProvinceName: "江苏",
                    CityList: [
                        {
                            CityId: "16544812353864782",
                            CityName: "苏州市"
                        },
                        {
                            CityId: "16544812353864778",
                            CityName: "南京市"
                        }
                    ]
                },
                {
                    ProvinceId: "16544791295722522",
                    ProvinceName: "陕西",
                    CityList: [
                        {
                            CityId: "16544812353864990",
                            CityName: "西安市"
                        }
                    ]
                },
                {
                    ProvinceId: "16544791295722514",
                    ProvinceName: "湖南",
                    CityList: [
                        {
                            CityId: "16544812353864884",
                            CityName: "长沙市"
                        }
                    ]
                },
                {
                    ProvinceId: "16544791295722512",
                    ProvinceName: "河南",
                    CityList: [
                        {
                            CityId: "16544812353864854",
                            CityName: "郑州市"
                        }
                    ]
                },
                {
                    ProvinceId: "16544791295722497",
                    ProvinceName: "天津",
                    CityList: [
                        {
                            CityId: "16544812353864705",
                            CityName: "天津市"
                        }
                    ]
                },
                {
                    ProvinceId: "16544791295722508",
                    ProvinceName: "安徽",
                    CityList: [
                        {
                            CityId: "16544812353864802",
                            CityName: "合肥市"
                        }
                    ]
                },
                {
                    ProvinceId: "16544791295722511",
                    ProvinceName: "山东",
                    CityList: [
                        {
                            CityId: "16544812353864839",
                            CityName: "青岛市"
                        }
                    ]
                },
                {
                    ProvinceId: "16544791295722515",
                    ProvinceName: "广东",
                    CityList: [
                        {
                            CityId: "16544812353864914",
                            CityName: "东莞市"
                        },
                        {
                            CityId: "16544812353864903",
                            CityName: "佛山市"
                        }
                    ]
                }
            ];
            AreaList.forEach(area => {
                // 添加新一线城市
                if(!this.query.IsNewFirstCityCheck){
                    // 判断是否选中省份
                    let obj1 = this.query.CollegeAreaList.find(f=>f.AreaId==area.ProvinceId);
                    if(!obj1){
                        // 循环新一线城市
                        area.CityList.forEach(city => {
                            // 判断是否选中城市
                            let obj2 = this.query.CollegeAreaList.find(f=>f.AreaId==city.CityId);
                            if(!obj2){
                                this.CollegeAreaListData.forEach(item => {
                                    if(item.AreaId==area.ProvinceId){
                                        item.CityList.push({AreaType:2,AreaId:city.CityId,AreaName:city.CityName});// 添加
                                    }
                                });
                            }
                        });
                    }
                }
                // 移除新一线城市
                else{
                    // 循环新一线城市
                    area.CityList.forEach(city => {
                        this.CollegeAreaListData.forEach(item => {
                            if(item.AreaId==area.ProvinceId){
                                item.CityList = item.CityList.filter(f=>f.AreaId!=city.CityId);// 移除
                            }
                        });
                    });
                }
            });
            this.CityCheckNumber();//更新已选城市数量
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 处理一线城市、新一线城市状态
        SetCityCheckStatus(){
            // 一线城市
            let City1 = [
                {
                    AreaId: "16544791295722496",
                    AreaName: "北京",
                    AreaType: 1
                },
                {
                    AreaId: "16544791295722498",
                    AreaName: "上海",
                    AreaType: 1
                },
                {
                    ProvinceId:"16544791295722515",
                    AreaId: "16544812353864898",
                    AreaName: "广州市",
                    AreaType: 2
                },
                {
                    ProvinceId:"16544791295722515",
                    AreaId: "16544812353864900",
                    AreaName: "深圳市",
                    AreaType: 2
                }
            ];
            // 新一线城市
            let City2 = [
                {
                    ProvinceId:"16544791295722518",
                    AreaId: "16544812353864937",
                    AreaName: "成都市",
                    AreaType: 2
                },
                {
                    ProvinceId:"16544791295722507",
                    AreaId: "16544812353864791",
                    AreaName: "杭州市",
                    AreaType: 2
                },
                {
                    AreaId: "16544791295722499",
                    AreaName: "重庆",
                    AreaType: 1
                },
                {
                    ProvinceId:"16544791295722513",
                    AreaId: "16544812353864871",
                    AreaName: "武汉市",
                    AreaType: 2
                },
                {
                    ProvinceId:"16544791295722506",
                    AreaId: "16544812353864782",
                    AreaName: "苏州市",
                    AreaType: 2
                },
                {
                    ProvinceId:"16544791295722522",
                    AreaId: "16544812353864990",
                    AreaName: "西安市",
                    AreaType: 2
                },
                {
                    ProvinceId:"16544791295722506",
                    AreaId: "16544812353864778",
                    AreaName: "南京市",
                    AreaType: 2
                },
                {
                    ProvinceId:"16544791295722514",
                    AreaId: "16544812353864884",
                    AreaName: "长沙市",
                    AreaType: 2
                },
                {
                    ProvinceId:"16544791295722512",
                    AreaId: "16544812353864854",
                    AreaName: "郑州市",
                    AreaType: 2
                },
                {
                    AreaId: "16544791295722497",
                    AreaName: "天津",
                    AreaType: 1
                },
                {
                    ProvinceId:"16544791295722508",
                    AreaId: "16544812353864802",
                    AreaName: "合肥市",
                    AreaType: 2
                },
                {
                    ProvinceId:"16544791295722511",
                    AreaId: "16544812353864839",
                    AreaName: "青岛市",
                    AreaType: 2
                },
                {
                    ProvinceId:"16544791295722515",
                    AreaId: "16544812353864914",
                    AreaName: "东莞市",
                    AreaType: 2
                },
                {
                    ProvinceId:"16544791295722507",
                    AreaId: "16544812353864792",
                    AreaName: "宁波市",
                    AreaType: 2
                },
                {
                    ProvinceId:"16544791295722515",
                    AreaId: "16544812353864903",
                    AreaName: "佛山市",
                    AreaType: 2
                }
            ];
            let number1=0;
            City1.forEach(area => {
                let obj = this.query.CollegeAreaList.find(f=>f.AreaId==area.AreaId);
                if(obj){
                    number1++;
                }
                else{
                    if(area.AreaType==2){
                        let obj2 = this.query.CollegeAreaList.find(f=>f.AreaId==area.ProvinceId);
                        if(obj2){
                            number1++;
                        }
                    }
                }
            });
            this.query.IsFirstCityCheck = number1==City1.length?true:false;
            let number2=0;
            City2.forEach(area => {
                let obj = this.query.CollegeAreaList.find(f=>f.AreaId==area.AreaId);
                if(obj){
                    number2++;
                }
                else{
                    if(area.AreaType==2){
                        let obj2 = this.query.CollegeAreaList.find(f=>f.AreaId==area.ProvinceId);
                        if(obj2){
                            number2++;
                        }
                    }
                }
            });
            this.query.IsNewFirstCityCheck = number2==City2.length?true:false;
        },
        // 省份/城市反选
        InvertCheck(){
            // 复制反选的省份及城市
            let subdata = deepClone(this.query.CollegeAreaList);
            // 重置省份及城市
            this.CollegeAreaListData.forEach(chek => {
                chek.CityList=[];
            });
            // 循环添加省份及城市
            this.CollegeAreaListData.forEach(item => {
                let sf_it = subdata.find(f=>(f.AreaType==1&&f.AreaId==item.AreaId));
                // 不是反选中的省份
                if(!sf_it){
                    let obj = this.CollegeScreen.CollegeAreaList.find(f=>f.ProvinceId==item.AreaId);
                    if(obj){
                        obj.CityList.forEach(city=>{
                            let cs_it = subdata.find(c=>(c.AreaType==2&&c.AreaId==city.CityId));
                            // 不是反选中的城市
                            if(!cs_it){
                                item.CityList.push({AreaType:2,AreaId:city.CityId,AreaName:city.CityName});
                            }
                        });
                    }
                }
            });
            this.CityCheckNumber();//更新已选城市数量
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 不看当前省份选中的城市(未使用)
        DontLook(item){
            let NoLookData = [];
            let obj = this.CollegeAreaListData.find(f=>f.AreaId==item.ProvinceId);
            if(obj){
                obj.CityList.forEach(city => {
                    NoLookData.push(city);
                });
                if(NoLookData.length>0){
                    this.query.CollegeAreaList=[];
                    this.CollegeScreen.CollegeAreaList.forEach(area=>{
                        let list = [];
                        area.CityList.forEach(data => {
                            // 排除不看的城市
                            if(!NoLookData.find(f=>f.AreaId==data.CityId)){
                                list.push({AreaType: 2,AreaId: data.CityId,AreaName: data.CityName});
                                // 是不看城市的省份添加城市一级条件
                                if(item.ProvinceId==area.ProvinceId){
                                    this.query.CollegeAreaList.push({AreaType: 2,AreaId: data.CityId,AreaName: data.CityName});
                                }
                            }
                        });
                        this.CollegeAreaListData.forEach(chek => {
                            if(chek.AreaId==area.ProvinceId){
                                chek.CityList=list;
                            }
                        });
                        // 其他省份添加省份一级条件
                        if(item.ProvinceId!=area.ProvinceId){
                            this.query.CollegeAreaList.push({AreaType: 1,AreaId: area.ProvinceId,AreaName: area.ProvinceName});
                        }
                        area.CheckNumber=list.length;
                    });
                    this.SetCityCheckStatus();// 处理一线城市、新一线城市状态
                    this.GetTotalCity();// 城市选择总数
                    this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
                }
                else{
                    this.$message.info("请选中该省份下不看的城市！");
                }
            }
        },
        // 城市选择总数
        GetTotalCity(){
            this.CityTotalNumber=0;
            if(this.CollegeScreen.CollegeAreaList){
                this.CollegeScreen.CollegeAreaList.forEach(item=>{
                    this.CityTotalNumber+=parseInt(item.CheckNumber);
                });
            }
        },
        // 绑定已选城市数量及参数组装
        CityCheckNumber(){
            this.query.CollegeAreaList=[];
            this.CollegeScreen.CollegeAreaList.forEach(item=>{
                let obj = this.CollegeAreaListData.find(f=>f.AreaId==item.ProvinceId);
                if(obj){
                    item.CheckNumber = obj.CityList.length;
                }
                // 更新提交参数
                if(item.CityList.length==obj.CityList.length){
                    // 城市全选，添加省份一级
                    this.query.CollegeAreaList.push({AreaType:1,AreaId:item.ProvinceId,AreaName:item.ProvinceName});
                }
                else{
                    // 选择了部分城市，循环添加城市一级
                    obj.CityList.forEach(city => {
                        this.query.CollegeAreaList.push(city);
                    });
                }
            });
            this.SetCityCheckStatus();// 处理一线城市、新一线城市状态
            this.GetTotalCity();// 城市选择总数
        },
        // 办学性质 选择/取消
        CollegeNatureIdListCheck(item_n){
            let obj = this.query.CollegeNatureIdList.find(f=>f==item_n.Id);
            if(obj){
                this.query.CollegeNatureIdList = this.query.CollegeNatureIdList.filter(f=>f!=item_n.Id);
            }
            else{
                this.query.CollegeNatureIdList.push(item_n.Id);
            }
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 办学性质 不限
        CollegeNatureIdListReset(){
            this.query.CollegeNatureIdList=[];
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 实力标签 选择/取消
        StrengthTagListCheck(item_s){
            let obj = this.query.StrengthTagList.find(f=>f==item_s.Id);
            if(obj){
                this.query.StrengthTagList = this.query.StrengthTagList.filter(f=>f!=item_s.Id);
            }
            else{
                this.query.StrengthTagList.push(item_s.Id);
            }
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 实力标签 不限
        StrengthTagListReset(){
            this.query.StrengthTagList=[];
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 招生类别 选择/取消
        EnrollCategoryIdListCheck(item_ec,t){
            if(t==1){
                let flag = this.query.EnrollCategoryIdList.includes(item_ec.EnrollCategoryId)
                if(flag){
                    this.query.EnrollCategoryIdList = this.query.EnrollCategoryIdList.filter(f=>f!==item_ec.EnrollCategoryId);
                }
                else{
                    this.query.EnrollCategoryIdList.push(item_ec.EnrollCategoryId);
                    this.query.DenyEnrollCategoryIdList = this.query.DenyEnrollCategoryIdList.filter(f=>f!==item_ec.EnrollCategoryId);
                }
            }
            else{
                let flag = this.query.DenyEnrollCategoryIdList.includes(item_ec.EnrollCategoryId)
                if(flag){
                    this.query.DenyEnrollCategoryIdList = this.query.DenyEnrollCategoryIdList.filter(f=>f!==item_ec.EnrollCategoryId);
                }
                else{
                    this.query.DenyEnrollCategoryIdList.push(item_ec.EnrollCategoryId);
                    this.query.EnrollCategoryIdList = this.query.EnrollCategoryIdList.filter(f=>f!==item_ec.EnrollCategoryId);
                }
            }
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 招生类别 不限
        EnrollCategoryIdListReset(item){
            this.query.EnrollCategoryIdList = this.query.EnrollCategoryIdList.filter(f=>f!=item.EnrollCategoryId);
            this.query.DenyEnrollCategoryIdList = this.query.DenyEnrollCategoryIdList.filter(f=>f!=item.EnrollCategoryId);
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 办学性质的学历层次切换
        EducationLevelCheck(val){
            if (this.query.EducationLevel === val) {
                this.query.EducationLevel = null;
            }
            else {
                this.query.EducationLevel = val;
            }
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 专业的学历层次切换
        MajorEducationLevelCheck(val){
            if(this.MajorScreenSelectLevel!=val){
                this.MajorScreenSelectLevel = val;
                this.GetMajorTreeList();//获取专业类别数据
                this.MajorMultipleSearchData=[];
                this.MajorMultipleSearchValue=[];
            }
        },
        // 获取专业类别数据
        GetMajorTreeList() {
            // 专业优先
            API.Web.GetMajorTreeList({EducationLevel:this.MajorScreenSelectLevel}).then(res => {
                this.MajorTypeData = res.data;
                this.MajorCheckNumber();//更新已选专业数量
                // 处理不接受专业下拉菜单数据
                res.data.forEach(item => {
                    let obj1 = {value:item.Id,label:item.Name,children:[]};
                    let arr2 = [];
                    item.SubList.forEach(item2=>{
                        let obj2 = {value:item2.Id,label:item2.Name,children:[]};
                        if(item2.SubList){
                            let arr3 = [];
                            item2.SubList.forEach(item3=>{
                                arr3.push({value:item3.Id,label:item3.Name});
                            });
                            obj2.children=arr3;
                        }
                        arr2.push(obj2);
                    });
                    obj1.children=arr2;
                    this.DenyMajorData.push(obj1);
                });
            });
        },
        // 专业类别选择
        MajorTypeCheck(item){
            let temp = this.query.MajorIdList.find(f => f === item.Id);// 判断是否存在当前专业类
            if(temp){
                this.query.MajorIdList = this.query.MajorIdList.filter(f=>f!=item.Id);// 移除查询条件的当前专业类
            }
            else{
                this.query.MajorIdList.push(item.Id);// 添加查询条件的当前专业类
            }
            this.MajorCheckNumber();//更新已选专业数量
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 专业类别 不限
        MajorTypeReset(){
            this.query.MajorIdList=[];
            this.MajorCheckNumber();//更新已选专业数量
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 专业多选搜索
        MajorMultipleSearchMethod(query){
            this.MajorMultipleSearchData = [];
            this.MajorMultipleSearchValue=[];
            if (query) {
                this.LoadingShow = true;//加载动画开始
                let data = deepClone(this.MajorTypeData);
                data.forEach(item1 => {
                    item1.SubList.forEach(item2 => {
                        if(item2.SubList){
                            if(item2.Name.indexOf(query)>-1){
                                this.MajorMultipleSearchData.push({label:item2.Name,value:item2.Id});
                            }
                            item2.SubList.forEach(item3=>{
                                if(item3.Name.indexOf(query)>-1){
                                    this.MajorMultipleSearchData.push({label:item3.Name,value:item3.Id});
                                }
                            })
                        }
                    });
                });
                this.LoadingShow = false;//加载动画开始
            }
            else {
                this.MajorMultipleSearchData = [];
                this.MajorMultipleSearchValue=[];
            }
        },
        // 快速查找专业 选中/取消
        MajorMultipleSearchChange(val){
            this.MajorMultipleSearchValue=[];
            let obj = this.MajorMultipleSearchData.find(f=>f.value==val);
            if(obj){
                this.MajorTypeCheck({Id:obj.value,Name:obj.label});
            }
        },
        // 绑定已选专业数量
        MajorCheckNumber(){
            this.MajorTypeData.forEach(item=>{
                let num=0;
                item.SubList.forEach(m=>{
                    if(this.query.MajorIdList.indexOf(m.Id)>-1){
                        num+=1;
                    }
                    if(m.SubList){
                        let thn=0;
                        m.SubList.forEach(t=>{
                            if(this.query.MajorIdList.indexOf(t.Id)>-1){
                                thn+=1;
                                num+=1;
                            }
                        });
                        m.CheckNumber = thn;
                    }
                });
                item.CheckNumber = num;
            });
        },
        // 三级专业显示
        ThreeMajorLayerShow(id,data){
            this.ThreeMajorShow = true;
            this.ThreeMajorData = data;
            this.MajorTypeHover = id;
        },
        // 三级专业隐藏
        ThreeMajorLayerHide(){
            this.ThreeMajorShow = false;
        },
        // 不接受专业选中变化
        DenyMajorChange(val){
            this.query.DenyMajorIdList=val;
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 纯净度最大数限制
        PurenessBlur(){
            if(this.query.GroupPureness>100){
                this.query.GroupPureness=100;
            }
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 分数范围改变
        ReportRangeChange(val){
            this.query.ScoreBegin=val[0];
            this.query.ScoreEnd=val[1];
            this.SetScoreLimit();// 设置推荐范围dom分数、提交参数
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 设置推荐范围dom分数、提交参数
        SetScoreLimit(){
            this.MajorCheckListStyle = 'height:'+((document.body.clientHeight-100) / 2)+'px';
            let sliders = document.getElementsByClassName('el-slider__button-wrapper');
            sliders[0].children[0].innerText = this.query.ScoreBegin;
            sliders[1].children[0].innerText = this.query.ScoreEnd;
        },
        // 设置推荐范围dom样式、分数、提交参数
        SetScoreStyleAndLimit() {
            this.LayerShow =  true;// 显示偏好弹层
            this.LoadingShow = false;//加载动画结束
            this.$nextTick(()=>{
                this.SetScoreLimit();// 设置推荐范围dom分数、提交参数
            });
        },
        // 获取统计数据、冲稳保 参数设置
        GetAutoGroupStat(){
            // 位次法
            if (this.User.wishCategory==0) {
                // 专业
                if (this.SelectWishWayObj.WishWay==2) {
                    GetAutoRecommendMajorAndCollegeGroupStat(this.query).then(res => {
                        if (res.code==0 && res.data) {
                            this.SetGroupStat(res.data);
                        }
                    });
                }
                // 院校、院校专业组
                else {
                    GetAutoRecommendCollegeGroupStat(this.query).then(res => {
                        if (res.code==0 && res.data) {
                            this.SetGroupStat(res.data);
                        }
                    });
                }
            }
            // 位点法
            else {
                // 专业
                if (this.SelectWishWayObj.WishWay==2) {
                    GetAutoRecommendMajorAndCollegeGroupStatByPredictScore(this.query).then(res => {
                        if (res.code==0 && res.data) {
                            this.SetGroupStat(res.data);
                        }
                    });
                }
                // 院校、院校专业组
                else {
                    GetAutoRecommendCollegeGroupStatByPredictScore(this.query).then(res => {
                        if (res.code==0 && res.data) {
                            this.SetGroupStat(res.data);
                        }
                    });
                }
            }
        },
        // 设置 冲稳保 通用
        SetGroupStat(data){
            this.AutoGroupStatData = data;
            // 按照3:4:3比例设置冲稳保数量
            let wcount = parseInt(this.SelectWishWayObj.WishCount?this.SelectWishWayObj.WishCount:0);
            let num1 = Math.round(wcount*0.3);
            let num2 = Math.round(wcount*0.4);
            let num3 = wcount-(num1+num2);
            let g1 = data.find(f=>f.GroupCode=='chong');
            if(g1){
                if(parseInt(g1.Count)>=num1){
                    this.SubmitGroupStatData.Group1=num1;
                }
                else{
                    this.SubmitGroupStatData.Group1=g1.Count;
                }
            }
            let g2 = data.find(f=>f.GroupCode=='wen');
            if(g2){
                if(parseInt(g2.Count)>=num2){
                    this.SubmitGroupStatData.Group2=num2;
                }
                else{
                    this.SubmitGroupStatData.Group2=g2.Count;
                }
            }
            let g3 = data.find(f=>f.GroupCode=='bao');
            if(g3){
                if(parseInt(g3.Count)>=num3){
                    this.SubmitGroupStatData.Group3=num3;
                }
                else{
                    this.SubmitGroupStatData.Group3=g3.Count;
                }
            }
            this.GroupStatChange();// 更新冲稳保提交参数
        },
        // 修改冲稳保数量时更新提交参数
        GroupStatChange(){
            Object.assign(this.query.WishCount, { 1: parseInt(this.SubmitGroupStatData.Group1) },{ 2: parseInt(this.SubmitGroupStatData.Group2) },{ 3: parseInt(this.SubmitGroupStatData.Group3) });
        },
        // 冲稳保数量不足时提示文字
        GetIsCount(){
            let num=parseInt(this.SubmitGroupStatData.Group1)+parseInt(this.SubmitGroupStatData.Group2)+parseInt(this.SubmitGroupStatData.Group3);
            return (num<parseInt(this.SelectWishWayObj.WishCount))?'(冲稳保总数不足'+this.SelectWishWayObj.WishCount+'个，差'+(this.SelectWishWayObj.WishCount-num)+'个)':'';
        },
        // 填报类型判定 位次/位点、院校专业组/专业/院校
        handleWishType() {
            // 位次法
            if (this.User.wishCategory==0) {
                // 专业
                if (this.SelectWishWayObj.WishWay==2) {
                    GetAutoRecommendMajorAndCollegeList(this.query).then(res => {
                        this.ReportCheckData = res.data;
                        this.ReportCheckData.forEach(it => {
                            this.$set(it, 'showText', true);
                        })
                        this.SortableSortList();
                        this.LayerShow = false;// 关闭偏好
                        this.LoadingShow = false;//加载动画结束
                    })
                }
                // 院校、院校专业组
                else {
                    GetAutoRecommendCollegeList(this.query).then(res => {
                        if (res.code==0 && res.data) {
                            res.data.forEach(it => {
                                it.SelectMajor = it.RecommendMajorList;
                                it.IsAdjust = true;
                            });
                            this.ReportCheckData = res.data;
                            this.ReportCheckData.forEach(it => {
                                this.$set(it, 'showText', true);
                                it.RecommendMajorList.forEach(it2 => {
                                    this.$set(it2, 'showText', true);
                                });
                            });
                        }
                        this.SortableSortList();
                        this.LayerShow = false;// 关闭偏好
                        this.LoadingShow = false;//加载动画结束
                    })
                }
            }
            // 位点法
            else {
                // 专业
                if (this.SelectWishWayObj.WishWay==2) {
                    GetAutoRecommendMajorAndCollegeListByPredictScore(this.query).then(res => {
                        this.ReportCheckData = res.data;
                        this.ReportCheckData.forEach(it => {
                            this.$set(it, 'showText', true);
                        })
                        this.SortableSortList();
                        this.LayerShow = false;// 关闭偏好
                        this.LoadingShow = false;//加载动画结束
                    })
                }
                // 院校、院校专业组
                else {
                    GetAutoRecommendCollegeListByPredictScore(this.query).then(res => {
                        if (res.code==0 && res.data) {
                            res.data.forEach(it => {
                                it.SelectMajor = it.RecommendMajorList;
                                it.IsAdjust = true;
                            });
                            this.ReportCheckData = res.data;
                            this.ReportCheckData.forEach(it => {
                                this.$set(it, 'showText', true);

                                it.RecommendMajorList.forEach(it2 => {
                                    this.$set(it2, 'showText', true);
                                });
                            });
                        }
                        this.SortableSortList();
                        this.LayerShow = false;// 关闭偏好
                        this.LoadingShow = false;//加载动画结束
                    })
                }
            }
        },
        
        getGroupColor(val){
            if(val=='冲'){
                return 'c';
            }
            else if(val=='稳'){
                return 'w';
            }
            else if(val=='保'){
                return 'b';
            }
        },
        // 标签
        handleTag(item) {
            let temp = item.CollegeStrengthTags || (item.FromCollege && item.FromCollege.CollegeStrengthTags)
            return temp ? temp.split(','):[]
        },
        handleNature(item) {
            let temp1 = item.CollegeProvinceName || (item.FromCollege && item.FromCollege.CollegeProvinceName)
            let temp2 = item.CollegeCityName || (item.FromCollege && item.FromCollege.CollegeCityName)
            let temp3 = item.CollegeCategoryName || (item.FromCollege && item.FromCollege.CollegeCategoryName)
            let temp4 = item.CollegeNatureName || (item.FromCollege && item.FromCollege.CollegeNatureName)

            let data = `${temp1||''} · ${temp2||''} · ${temp3||''} · ${temp4||''}`
            return data
        },
        //专业限报提醒
        MajorLimitWarning(arr){
            return MajorLimitFormat(arr,this.User);
        },
        //关闭、打开 专业限报提醒
        MajorLimitItemColseOpen(id){
            let obj = document.getElementById(id);
            if(obj.children[0].className.indexOf('el-icon-d-arrow-right')>-1){
                obj.children[1].style.display="none";
                obj.children[0].classList.remove('el-icon-d-arrow-right');
                obj.children[0].classList.add('el-icon-d-arrow-left');
                obj.style.height="0px";
            }
            else{
                obj.children[1].style.display="block";
                obj.children[0].classList.remove('el-icon-d-arrow-left');
                obj.children[0].classList.add('el-icon-d-arrow-right');
                obj.style.height="100%";
            }
        },
        // 显示设置偏好
        SetLike(){
            this.LayerShow = true;// 显示偏好
            this.$nextTick(()=>{
                this.SetScoreLimit();// 设置推荐范围dom分数、提交参数
            });
        },
        // 偏好数据重置
        ResetLikeData(){
            this.query.CollegeAreaList= [];
            this.query.EducationLevel= null;
            this.query.CollegeNatureIdList= [];
            this.query.StrengthTagList= [];
            this.query.MajorIdList= [];
            this.query.DenyMajorIdList= [];
            this.query.EnrollCategoryIdList= [];
            this.query.DenyEnrollCategoryIdList= [];
            this.query.LearningCostBegin= null;
            this.query.LearningCostEnd= null;
            this.query.PlanPersonsMin= null;
            this.query.MajorCount= null;
            this.query.GroupPureness= null;
            this.query.WishCount= {};
            this.query.AreaData =[];
            this.query.IsFirstCityCheck=false;
            this.query.IsNewFirstCityCheck=false;
            this.CollegeAreaListData=[];
            this.CityTotalNumber=0;
            this.CollegeScreen.CollegeAreaList.forEach(item => {
                item.CheckNumber=0;
                this.CollegeAreaListData.push({AreaType: 1,AreaId: item.ProvinceId,AreaName: item.ProvinceName,CityList:[]});
            });
            setStore("LargeModelLikeData_"+this.LoginInfo.UserId,this.query);// 缓存当前学生的偏好数据
            this.MajorCheckNumber();//更新已选专业数量
            this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
        },
        // 提交偏好
        LikeSetSubmit(){
            if((this.SubmitGroupStatData.Group1+this.SubmitGroupStatData.Group2+this.SubmitGroupStatData.Group3)>0){
                this.LoadingShow = true;//加载动画开始
                this.query.AreaData = this.CollegeAreaListData;// 处理城市选中
                setStore("LargeModelLikeData_"+this.LoginInfo.UserId,this.query);// 缓存当前学生的偏好数据
                let st = setTimeout(()=>{
                    this.handleWishType();// 填报类型判定 位次/位点、院校专业组/专业/院校
                    clearTimeout(st);
                },500);
            }
            else{
                this.$message.warning('您的推荐数量为0个，不能生成志愿表！');
            }
        },
        // 保存志愿表
        WishSave(){
            if (!this.ReportCheckData || this.ReportCheckData.length<=0) {
                this.$message.warning('暂无需要保存的数据！')
                return
            }
            let id = this.$route.query.ID
            if (!id) {
                this.$message.error('未获取到学生id信息！')
                return false
            }
            this.SaveQuery.StudentId = id
            this.SaveQuery.ExamProvinceId = this.User.ProvinceId
            this.SaveQuery.ExamProvinceName = this.User.ProvinceName || null
            this.SaveQuery.ExamYear = this.User.Year

            this.SaveQuery.SubjectType = this.User.SubjectType
            this.SaveQuery.Subjects = this.User.SubjectList?(this.User.SubjectList.join()):null

            this.SaveQuery.BatchId = this.SelectRecommendBatch.BatchId
            this.SaveQuery.BatchName = this.SelectRecommendBatch.BatchName || null

            this.SaveQuery.WishWay = this.SelectWishWayObj.WishWay
            this.SaveQuery.WishType = this.User.wishCategory
            this.SaveQuery.WishName = null

            this.SaveQuery.Score = this.User.FinalScore?this.User.FinalScore:this.User.Score
            this.SaveQuery.RankHigh = this.RecommendBatch.RankHigh
            this.SaveQuery.RankLow = this.RecommendBatch.RankLow
            this.SaveQuery.Rank = this.RecommendBatch.Rank || null
            
            this.SaveQuery.ScoreDiff = this.SaveQuery.Score - this.SelectRecommendBatch.BatchScore
            this.SaveQuery.PlanYear = this.SelectRecommendBatch.PlanYear
            this.SaveQuery.RecommendVersion = this.SelectRecommendBatch.RecommendVersion
            this.SaveQuery.RecommendKey = this.SelectRecommendBatch.RecommendKey

            this.SaveQuery.YearList = this.SelectRecommendBatch.YearList

            this.SaveQuery.ScoreEqualDic = this.SelectRecommendBatch.ScoreEqual || null
            this.SaveQuery.RecordList = []

            if(this.modifyObj.ID){
                this.SaveQuery.ID=this.modifyObj.ID;
            }
            else {
                delete this.SaveQuery.ID;
            }
            this.handleParams()
        },

        handleParams() {
            // 1
            if (this.CollegeOrMajorGroupId != 2) {
                
                this.ReportCheckData.map((item, index) => {
                    let data = []
                    
                    item.SelectMajor.map((sItem, sIndex) => {

                        delete item.MajorPredictScoreMin
                        delete item.MajorPredictScoreMax

                        sItem.MajorEnrollCategories = sItem.MajorEnrollCategories || null

                        data.push({...sItem, MajorNum: sIndex+1})
                    })
                    this.SaveQuery.RecordList.push({...item, MajorList:data, WishNum: index+1})
                })

                let params = deepClone(this.SaveQuery)

                params.RecordList.forEach(it=>{
                    this.$delete(it, 'SelectMajor')
                })

                this.$prompt('请输入志愿名称', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    params.WishName = value
                    this.LoadingShow = true;//加载动画开始
                    params.RecordList.forEach(it => {
                        delete it.showText

                        it.MajorList.forEach(it2 => {
                            delete it2.showText
                        })
                    })
                    SaveWish(params).then(res => {
                        if (res.code==0) {
                            this.modifyObj.ID=res.data;
                            setStore('modifyObj', this.modifyObj);
                            this.User.WishWay = this.SelectWishWayObj.WishWay;
                            this.User.WishId = res.data;
                            setStore('studentReport', this.User);
                            setStore('ReportCheckDataObj', this.ReportCheckData)
                            setStore('ReportCheckDataObjVersion', this.SelectRecommendBatch.RecommendVersion)
                            this.$message.success('志愿保存成功')
                            this.$parent.FastWishStartNewShow=false
                            this.$parent.WishTableShow = true
                            this.$nextTick(()=>{
                                this.$parent.$refs.refWishTable.BackWishListShow = true;
                            })
                        } else {
                            this.$message.error(res.message)
                        }
                        this.LoadingShow = false;//加载动画结束
                    }).catch(() => {
                        this.LoadingShow = false;//加载动画结束
                    })
                })
            }

            // 2
            if (this.CollegeOrMajorGroupId == 2) {
                
                this.ReportCheckData.map((item, index) => {
                    if (item.FromCollege) {
                        item = {...item.FromCollege, ...item}
                    }
                    delete item.FromCollege

                    item.MajorEnrollCategories = item.MajorEnrollCategories || null

                    this.SaveQuery.RecordList.push({...item, WishNum: index+1})
                })
                let params2 = deepClone(this.SaveQuery)
                params2.RecordList.forEach(it=>{
                    this.$delete(it, 'FromCollege')
                })

                this.$prompt('请输入志愿名称', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    params2.WishName = value
                    this.LoadingShow = true;//加载动画开始
                    params2.RecordList.forEach(it => {
                        delete it.showText
                    })
                    SaveWishMajorAndCollege(params2).then(res => {
                        if (res.code==0) {
                            this.modifyObj.ID=res.data;
                            setStore('modifyObj', this.modifyObj);
                            this.User.WishWay = this.SelectWishWayObj.WishWay;
                            this.User.WishId = res.data;
                            setStore('studentReport', this.User);
                            setStore('ReportCheckDataObj', this.ReportCheckData)
                            setStore('ReportCheckDataObjVersion', this.SelectRecommendBatch.RecommendVersion)
                            this.$message.success('志愿保存成功')
                            this.$parent.FastWishStartNewShow=false
                            this.$parent.WishTableShow = true
                            this.$nextTick(()=>{
                                this.$parent.$refs.refWishTable.BackWishListShow = true;
                            })
                        } else {
                            this.$message.error(res.message)
                        }
                        this.LoadingShow = false;//加载动画结束
                    }).catch(() => {
                        this.LoadingShow = false;//加载动画结束
                    })
                })
            }
        },
        // 修改
        WishEdit(){
            setStore('ReportCheckDataObj', this.ReportCheckData)
            this.$parent.FastWishStartNewShow=false
            this.$parent.WishRecommendShow=true
            this.$nextTick(()=>{
                this.$parent.$refs.refRecommend.modifyWish();
                this.$parent.$refs.refRecommend.getlayerbacksytle();
            });
        },
        // 院校拖动排序
        SortableSortList() {
            this.$nextTick(() => {
                setTimeout(() => {
                    let that = this;
                    Sortable.create(document.getElementById('WishSortTable'),{
                        animation: 300,
                        easing: "cubic-bezier(1, 0, 0, 1)", // 移动动画。默认为 null。例如 https://easings.net/。
                        fallbackTolerance: 50, // 以像素为单位指定鼠标在被视为拖动之前应移动的距离
                        swapThreshold: 50, // 交换区域的阈值
                        onEnd({newIndex, oldIndex}){
                            // 拖动结束（重置排序）
                            let temp = that.ReportCheckData.splice(oldIndex, 1)
                            that.ReportCheckData.splice(newIndex, 0, ...temp)
                        }
                    });
                }, 0)
            })
        },
        // 修改院校排序
        UpdateSort(index, i){
            this.$prompt('请输入正整数', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^[1-9]\d*$/,
                inputErrorMessage: '只能输入正整数',
                inputValue:index
            }).then(({ value }) => {
                value = value - 1
                if (value > this.ReportCheckData.length - 1) {
                    value = this.ReportCheckData.length - 1
                }
                
                let temp = this.ReportCheckData.splice(i, 1)
                this.ReportCheckData.splice(value, 0, ...temp)
            }).catch(() => {
            });
        },
        // 院校向上排序
        CollegeWishSortUp(it, i) {
            if (i <= 0) return false
            let temp = this.ReportCheckData.splice(i-1, 1, this.ReportCheckData[i])
            this.ReportCheckData.splice(i, 1, ...temp)
        },
        // 院校向下排序
        CollegeWishSortDown(it, i) {
            if (i >= this.ReportCheckData.length-1) return false
            let temp = this.ReportCheckData.splice(i+1, 1, this.ReportCheckData[i])
            this.ReportCheckData.splice(i, 1, ...temp)
        },
        // 移除院校及专业
        CollegeWishRemove(it, i) {
            this.ReportCheckData.splice(i, 1)
        },
        // 专业向上排序
        collegeMajorSortUp(i, mi) {
            if (mi <= 0) return false
            let temp = this.ReportCheckData[i].SelectMajor.splice(mi-1, 1, this.ReportCheckData[i].SelectMajor[mi])
            this.ReportCheckData[i].SelectMajor.splice(mi, 1, ...temp)
        },
        // 专业向下排序
        collegeMajorSortDown(i, mi) {
            if (mi >= this.ReportCheckData[i].SelectMajor.length-1) return false
            let temp = this.ReportCheckData[i].SelectMajor.splice(mi+1, 1, this.ReportCheckData[i].SelectMajor[mi])
            this.ReportCheckData[i].SelectMajor.splice(mi, 1, ...temp)
        },
        // 移除专业
        collegeMajorRemove(i, mi) {
            this.ReportCheckData[i].SelectMajor.splice(mi, 1)
            if (!this.ReportCheckData[i].SelectMajor || this.ReportCheckData[i].SelectMajor.length <= 0) {
                this.ReportCheckData.splice(i, 1)
            }
        },
        WishMajorSortUp (it, i) {
            if (i <= 0) return false
            let temp = this.ReportCheckData.splice(i-1, 1, this.ReportCheckData[i])
            this.ReportCheckData.splice(i, 1, ...temp)
        },
        WishMajorSortDown (it, i) {
            if (i >= this.ReportCheckData.length-1) return false
            let temp = this.ReportCheckData.splice(i+1, 1, this.ReportCheckData[i])
            this.ReportCheckData.splice(i, 1, ...temp)
        },
        WishMajorRemove (it, i) {
            this.ReportCheckData.splice(i, 1)
        },
        // 导入偏好 显示
        LayerTestShow(){
            this.TestLikeImportShow=true;
            let layer = document.getElementById('testlikeimportlayerids').classList;
            layer.add("layer_animate_show");
            layer.remove("layer_animate_hide");
            let box = document.getElementById("testlikeimportboxids").classList;
            box.add("box_animate_show");
            box.remove("box_animate_hide");
            let msdata = getStore("MessageListLikeData_"+this.LoginInfo.UserId);// 获取当前学生的提问
            if(msdata){
                this.UserLikeData.MessageList=JSON.parse(msdata);
                // 刷新滚动条
                this.$nextTick(()=>{
                    let obj = document.getElementById("answerboxid");
                    if(obj){
                        for(let i=0;i<obj.children.length;i++){
                            if(obj.children[i].className.indexOf('el-scrollbar__wrap')>-1){
                                obj.children[i].scrollTop = obj.children[i].scrollHeight;
                                break;
                            }
                        }
                    }
                });
            }
            const UserMessageInput = document.getElementById('UserMessageInput');
            if(UserMessageInput){
                UserMessageInput.addEventListener('keydown', this.UserMessageInputKeyDown);
            }
        },
        UserMessageInputKeyDown(e){
            let that = this;
            // Shift+Enter 换行
            if (e.key === 'Enter' && e.shiftKey) {
                // 允许默认的换行行为
                return;
            }
            // Enter 发送消息（没有按下Shift）
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault(); // 阻止默认的换行行为
                that.WriterText();// 输入内容
            }
        },
        // 导入偏好 隐藏
        LayerTestHide(){
            const UserMessageInput = document.getElementById('UserMessageInput');
            if(UserMessageInput){
                UserMessageInput.removeEventListener('keydown', this.UserMessageInputKeyDown);
            }
            let box = document.getElementById("testlikeimportboxids").classList;
            box.add("box_animate_hide");
            box.remove("box_animate_show");
            let layer = document.getElementById('testlikeimportlayerids').classList;
            layer.add("layer_animate_hide");
            layer.remove("layer_animate_show");
            let st = setTimeout(()=>{
                this.TestLikeImportShow=false;
                this.TestListCheck={};
                clearTimeout(st);
            },300);
        },
        // 前往测评
        GoTest(val){
            let url = this.GetTestUrl(val);// 测评链接
            this.TestIframeShow=true;
            this.$nextTick(()=>{
                let obj = document.getElementById('addiframebox');
                if(obj){
                    let ifbox = document.createElement('iframe');
                    ifbox.style.width="100%";
                    ifbox.style.height="100%";
                    ifbox.style.border='0';
                    ifbox.src=(window.location.origin+'/#'+url);
                    obj.appendChild(ifbox);
                }
            });
        },
        // Iframe返回
        TestIframeBack(){
            this.TestIframeShow=false;
        },
        // 测评链接
        GetTestUrl(val){
            let url="";
            if(val==1){
                url="/test/MBTI?StudentId=" + this.query.StudentId + "&OrgName=" + this.$ls.get("userdata").OrgName;
            }
            else if(val==2){
                url="/test/hollandTest?StudentId=" + this.query.StudentId + "&OrgName=" + this.$ls.get("userdata").OrgName;
            }
            else if(val==3){
                url="/test/personalityTest?StudentId=" + this.query.StudentId + "&OrgName=" + this.$ls.get("userdata").OrgName;
            }
            else if(val==4){
                url="/new-exam-test/new-exam-choose?StudentId=" + this.query.StudentId + "&OrgName=" + this.$ls.get("userdata").OrgName;
            }
            else if(val==6){
                url="/allround/allroundtest?StudentId=" + this.query.StudentId + "&OrgName=" + this.$ls.get("userdata").OrgName;
            }
            return url;
        },
        // 复制测评链接
        CopyTest(val){
            const clipboard = new Clipboard(".tag-read");
            clipboard.on("success", (e) => {
                this.$message({type: "success",message: this.GetTestTypeName(val)+"地址已复制，可通过微信、QQ等发送给学生。"});
                clipboard.destroy();// 释放内存
            });
            clipboard.on("error", (e) => {
                this.$message({type: "info",message: "该浏览器不支持自动复制"});// 不支持复制
                clipboard.destroy();// 释放内存
            });
        },
        // 获取测评类别名称
        GetTestTypeName(type){
            if(type==6){
                return "综合测评";
            }
            else if(type==1){
                return "MBTI性格测评";
            }
            else if(type==2){
                return "霍兰德职业测评";
            }
            else if(type==3){
                return "中学生人格测评";
            }
            else if(type==4){
                return "新高考选科测评";
            }
        },
        // 测评选中/取消
        TestCheck(item){
            this.TestListCheck=item;
            let st = setTimeout(()=>{
                this.ImpotTestClose();// 测评关闭
                let code = '';
                if(item.TestType==1){
                    code="MBTI性格测评代码为："+item.ResultCode
                }
                else if(item.TestType==2){
                    code="霍兰德职业测评代码为："+item.ResultCode
                }
                else if(item.TestType==3){
                    code="中学生人格测评代码为："+item.ResultCode
                }
                else if(item.TestType==4){
                    code="新高考选科测评代码为："+item.ResultCode
                }
                else if(item.TestType==6){
                    code="综合测评：";
                    if(item.Answers){
                        item.Answers=JSON.parse(item.Answers);
                    }
                    item.Answers.forEach(ans=>{
                        if(ans.Dimensionality==1){
                            code+="兴趣维度代码为："+ans.Result+'；';
                        }
                        else if(ans.Dimensionality==2){
                            code+="能力维度代码为："+ans.Result+'；';
                        }
                        else if(ans.Dimensionality==3){
                            code+="性格维度代码为："+ans.Result+'；';
                        }
                        else if(ans.Dimensionality==4){
                            code+="价值观维度代码为："+ans.Result+'；';
                        }
                        else if(ans.Dimensionality==5){
                            code+="学科维度代码为："+ans.Result+'；';
                        }
                    });
                }
                this.UserLikeData.Message=code;
                this.WriterText();
                clearTimeout(st);
            },100);
        },
        // 测评显示
        ImpotTestShow(){
            this.IsImportTest=true;
            let st = setTimeout(()=>{
                let con = document.getElementById("testlistids");
                if(con){
                    con.classList.add("content_animate_show");
                }
                clearTimeout(st);
            },100);
        },
        // 测评关闭
        ImpotTestClose(){
            let con = document.getElementById("testlistids");
            if(con){
                con.classList.remove("content_animate_show");
            }
            this.IsImportTest=false;
        },
        // 获取测评数据
        GetTestList(val){
            this.QuestionTipsShow=false;
            TestList({StudentId: this.LoginInfo.UserId,pageIndex: 1,pageSize: 1000}).then((res) => {
                if (res.code == 0 && res.data) {
                    this.TestListData = res.data.Data.filter(f=>f.TestType!=5);
                    this.ImpotTestShow();// 测评显示
                    if(val){
                        this.$message.success("已刷新测评数据！");
                    }
                }
            });
        },
        // 去做测评
        MakeTestBoxShow(){
            this.MakeTestShow=true;
            let st = setTimeout(()=>{
                let con = document.getElementById("MakeTestBoxId");
                if(con){
                    con.classList.add("maketest_animate_show");
                    con.classList.remove("maketest_animate_hide");
                }
                clearTimeout(st);
            },50);
        },
        // 做测评关闭
        MakeTestBoxClose(){
            let con = document.getElementById("MakeTestBoxId");
            if(con){
                con.classList.add("maketest_animate_hide");
                con.classList.remove("maketest_animate_show");
            }
            let st = setTimeout(()=>{
                this.MakeTestShow=false;
                clearTimeout(st);
            },300);
        },
        // 提问示例
        QuestionTipsBtn(){
            if(this.QuestionTipsShow){
                this.QuestionTipsShow=false;
            }
            else{
                this.QuestionTipsShow=true;
            }
        },
        // 跳过测评导入
        SkipCloseStep(){
            this.QuestionTipsShow=false;
            this.LayerTestHide();// 导入偏好 隐藏
        },
        // 重置
        SkipReset(){
            this.QuestionTipsShow=false;
            this.TestListCheck={};
            this.UserLikeData={
                Message:"",
                MessageList:[]
            };
            removeStore("MessageListLikeData_"+this.LoginInfo.UserId);// 移除当前学生的提问缓存
        },
        // 输入内容
        WriterText(){
            if(!this.UserLikeData.Message){
                this.$message.info("请输入内容！");return;
            }
            this.UserLikeData.MessageList.push(this.UserLikeData.Message);
            this.UserLikeData.Message="";
            this.QuestionTipsShow=false;
            // 刷新滚动条
            this.$nextTick(()=>{
                let obj = document.getElementById("answerboxid");
                if(obj){
                    for(let i=0;i<obj.children.length;i++){
                        if(obj.children[i].className.indexOf('el-scrollbar__wrap')>-1){
                            obj.children[i].scrollTop = obj.children[i].scrollHeight;
                            break;
                        }
                    }
                }
            });
        },
        // 导入偏好
        ImportLikeShow(){
            if(this.UserLikeData.MessageList.length==0){
                if(!this.UserLikeData.Message){
                    this.$message.info("请输入内容！");return;
                }
                else{
                    this.WriterText();// 输入内容
                }
            }
            else{
                if(this.UserLikeData.Message){
                    this.WriterText();// 输入内容
                }
            }
            this.QuestionTipsShow=false;
            this.AnalysisLayerShow=true;
            // 提交接口 获取偏好数据
            GetAutoRecommendDemandAnalysis({ProvinceId:this.User.ProvinceId,BatchId:this.SelectRecommendBatch.BatchId,Message: this.UserLikeData.Message,MessageList: this.UserLikeData.MessageList}).then(res => {
                if(res.code==0) {
                    setStore("MessageListLikeData_"+this.LoginInfo.UserId,this.UserLikeData.MessageList);// 缓存当前学生的提问
                    // 处理地区数据
                    if(res.data.areas.length>0){
                        this.CollegeAreaListData.forEach(chek => {
                            chek.CityList=[];
                        });
                        res.data.areas.forEach(area => {
                            for(let i=0;i<this.CollegeScreen.CollegeAreaList.length;i++){
                                let ch = 0;
                                // 选中省
                                if(this.CollegeScreen.CollegeAreaList[i].ProvinceName.indexOf(area)>-1){
                                    this.CollegeAreaListData.forEach(chek => {
                                        if(chek.AreaId==this.CollegeScreen.CollegeAreaList[i].ProvinceId){
                                            if(chek.CityList.length!=this.CollegeScreen.CollegeAreaList[i].CityList.length){
                                                chek.CityList = [];
                                                this.CollegeScreen.CollegeAreaList[i].CityList.forEach(ot => {
                                                    chek.CityList.push({AreaType:2,AreaId:ot.CityId,AreaName:ot.CityName});// 添加
                                                });
                                            }
                                        }
                                    });
                                    ch=1;
                                }
                                else{
                                    // 是否选中市
                                    for(let y=0;y<this.CollegeScreen.CollegeAreaList[i].CityList.length;y++){
                                        // 选中市
                                        if(this.CollegeScreen.CollegeAreaList[i].CityList[y].CityName.indexOf(area)>-1){
                                            this.CollegeAreaListData.forEach(item => {
                                                if(item.AreaId==this.CollegeScreen.CollegeAreaList[i].ProvinceId){
                                                    let temp = item.CityList.find(f => f.AreaId === this.CollegeScreen.CollegeAreaList[i].CityList[y].CityId);// 判断当前城市是否已选中
                                                    if(!temp){
                                                        item.CityList.push({AreaType:2,AreaId:this.CollegeScreen.CollegeAreaList[i].CityList[y].CityId,AreaName:this.CollegeScreen.CollegeAreaList[i].CityList[y].CityName});// 添加
                                                    }
                                                }
                                            });
                                            ch=1;
                                            break;// 跳出市循环
                                        }
                                    }
                                }
                                // 跳出省循环
                                if(ch==1){
                                    break;
                                }
                            }
                            this.CityCheckNumber();// 绑定已选城市数量及参数组装
                        });
                    }
                    // 处理专业数据
                    if(res.data.majors.length>0){
                        this.query.MajorIdList=[];
                        res.data.majors.forEach(major =>{
                            for(let z=0;z<this.MajorTypeData.length;z++){
                                let ma = 0;
                                for(let w=0;w<this.MajorTypeData[z].SubList.length;w++){
                                    if(this.MajorTypeData[z].SubList[w].SubList){
                                        for(let x=0;x<this.MajorTypeData[z].SubList[w].SubList.length;x++){
                                            if(this.MajorTypeData[z].SubList[w].SubList[x].Name.indexOf(major)>-1){
                                                let temp = this.query.MajorIdList.find(f => f === this.MajorTypeData[z].SubList[w].SubList[x].Id);// 判断是否存在当前专业类
                                                if(!temp){
                                                    this.query.MajorIdList.push(this.MajorTypeData[z].SubList[w].SubList[x].Id);// 添加
                                                }
                                                ma = 1;
                                                break;
                                            }
                                        }
                                        if(ma==1){
                                            break;
                                        }
                                    }
                                }
                                if(ma==1){
                                    break;
                                }
                            }
                            this.MajorCheckNumber();//更新已选专业数量
                        });
                    }
                    // 处理办学性质
                    if(res.data.collegeNatureList.length>0){
                        this.query.CollegeNatureIdList=[];
                        res.data.collegeNatureList.forEach(nature=>{
                            for(let n=0;n<this.CollegeScreen.CollegeNatureList.length;n++){
                                if(this.CollegeScreen.CollegeNatureList[n].Name.indexOf(nature)>-1){
                                    let obj = this.query.CollegeNatureIdList.find(f=>f==this.CollegeScreen.CollegeNatureList[n].Id);
                                    if(!obj){
                                        this.query.CollegeNatureIdList.push(this.CollegeScreen.CollegeNatureList[n].Id);
                                    }
                                }
                            }
                        });
                    }
                    // 处理实力标签
                    if(res.data.strengthTagList.length>0){
                        this.query.StrengthTagList=[];
                        res.data.strengthTagList.forEach(tag=>{
                            for(let t=0;t<this.CollegeScreen.StrengthTagList.length;t++){
                                if(this.CollegeScreen.StrengthTagList[t].Name.indexOf(tag)>-1){
                                    let obj = this.query.StrengthTagList.find(f=>f==this.CollegeScreen.StrengthTagList[t].Id);
                                    if(!obj){
                                        this.query.StrengthTagList.push(this.CollegeScreen.StrengthTagList[t].Id);
                                    }
                                }
                            }
                        });
                    }
                    // 处理招生类别
                    if(res.data.enrollcategory&&res.data.enrollcategory!='普通类'){
                        this.query.EnrollCategoryIdList = [];
                        this.query.DenyEnrollCategoryIdList = [];
                        let eclist = this.SelectWishWayObj.EnrollCategoryList.filter(f=>f.EnrollCategoryId!=0);
                        for(let e=0;e<eclist.length;e++){
                            if(eclist[e].EnrollCategoryName.indexOf(res.data.enrollcategory)>-1){
                                let obj = this.query.EnrollCategoryIdList.find(f=>f==eclist[e].EnrollCategoryId);
                                if(!obj){
                                    this.query.EnrollCategoryIdList.push(eclist[e].EnrollCategoryId);
                                }
                            }
                        }
                    }
                    // 学费
                    if(res.data.learningCostBegin||res.data.learningCostBegin==0){
                        this.query.LearningCostBegin=res.data.learningCostBegin;
                    }
                    if(res.data.learningCostEnd){
                        this.query.LearningCostEnd=res.data.learningCostEnd;
                    }
                    this.$nextTick(()=>{
                        this.GetAutoGroupStat();// 获取统计数据、冲稳保 参数设置
                        this.AnalysisLayerShow=false;
                        this.LayerTestHide();// 导入偏好 隐藏
                        this.AnalysisSuccessShow=true;
                        this.SuccessTimer = setInterval(() => {
                            if (this.SuccessTime > 1) {
                                this.SuccessTime--;
                            }
                            else {
                                this.AnalysisSuccessShow=false;
                                this.SuccessTime=5;
                                clearInterval(this.SuccessTimer);
                            }
                        }, 1000);
                    });
                }
                else{
                    this.AnalysisLayerShow=false;
                }
            });
        },
        // 手动关闭提示
        AnalysisSuccessColose(){
            this.AnalysisSuccessShow=false;
            this.SuccessTime=5;
            clearInterval(this.SuccessTimer);
        },
        // 客户端打字效果
        DefaultTypeWriter(text, speed) {
            let txt = "根据您完成的综合测评结论，系统为您推荐以下专业：<br/>数学与应用数学、信息与计算科学、数理基础科学、数据计算及应用、物理学、应用物理学、系统科学与工程、量子信息科学、电子信息工程、电子科学与技术、通信工程、微电子科学与工程、光电信息科学与工程、广播电视工程、集成电路设计与集成系统、电磁场与无线技术、电波传播与天线、电子信息科学与技术、电信工程及管理、应用电子技术教育、海洋信息工程、智能测控工程、智能视觉工程、智能视听工程、计算机科学与技术、软件工程、网络工程、信息安全、物联网工程、数字媒体技术、智能科学与技术、空间信息与数字技术、电子与计算机工程、数据科学与大数据技术、网络空间安全、新媒体技术、服务科学与工程、密码科学与技术";
            let i = 0;
            const interval = setInterval(() => {
                if (i < txt.length) {
                    this.AnswerContent += txt.charAt(i);
                    i++;
                }
                else {
                    clearInterval(interval);
                }
            }, 5);
        },
        ZMStr(index){
            let strArr = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
            if(index>25){
                return index+1;
            }
            else{
                return strArr[index];
            }
        },
    }
}
</script>
<style scoped lang="less">
.fastwish_start{
    user-select: none;
    max-width: 1420px;
    margin: auto;
    .loading_box{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 800;
        background-color: rgba(0,0,0,0.4);
        .loadimg{
            width: 100px;
            height: 100px;
            position: absolute;
            left: calc(50% - 50px);
            top: calc(50% - 50px);
            z-index: 801;
            background: url(../../assets/images/loading-ico.png) no-repeat center center / 100px;
            animation: loading_animate 3s linear infinite;
            -webkit-animation: loading_animate 3s linear infinite;
            @keyframes loading_animate {
                from {
                    transform: rotate(0deg);
                }
                to {
                    transform: rotate(360deg);
                }
            }
            @-webkit-keyframes loading_animate {
                from {
                    transform: rotate(0deg);
                }
                to {
                    transform: rotate(360deg);
                }
            }
        }
        .loadicon{
            width: 100px;
            height: 100px;
            position: absolute;
            left: calc(50% - 50px);
            top: calc(50% - 50px);
            z-index: 802;
            background: url(../../assets/images/ai-icon.png) no-repeat center center / 30px;
        }
    }
    .testlikeimportbox{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 110;
        background-color: rgba(0,0,0,0.4);
        .tbox{
            width: 1000px;
            height: calc(100% - 40px);
            background-color: #fff;
            border-radius: 5px;
            position: absolute;
            left: calc(50% - 500px);
            top: 20px;
            z-index: 2;
            overflow: hidden;
            .con_box{
                position: relative;
                height: 100%;
                width: 100%;
            }
            .topbox{
                width: 100%;
                height: 46px;
                background-color: #fff;
                border-bottom: 1px solid #ddd;
                position: relative;
                .zizhushou{
                    display: inline-block;
                    margin-top: 6px;
                    width: 120px;
                    margin-left: 15px;
                    opacity: 0.9;
                }
                i.el-icon-close{
                    position: absolute;
                    right: 0px;
                    top: 3px;
                    width: 40px;
                    height: 40px;
                    text-align: center;
                    line-height: 40px;
                    font-size: 20px;
                    color: #c0c0c0;
                    transition: all 0.2s;
                    -webkit-transition: all 0.2s;
                }
                i.el-icon-close:hover{
                    cursor: pointer;
                    color: red;
                    transform: rotate(90deg);
                    -webkit-transform: rotate(90deg);
                }
            }
            .answerbox{
                width: 100%;
                height:calc(100% - 238px);
                position: relative;
                .toptip{
                    position: absolute;
                    left: 0;
                    top: 0;
                    z-index: 1;
                    width:100%;
                    height:30px;
                    line-height:30px;
                    text-align: center;
                    color:#979797;
                    font-size:12px;
                    background-color: #fff;
                }
                .contip{
                    width: 600px;
                    height: 138px;
                    position: absolute;
                    left: 6px;
                    bottom: -3px;
                    z-index: 2;
                    color:#6e6e6e;
                    font-size:14px;
                    line-height:22px;
                    background: url(../../assets/images/tipsico.png) no-repeat center center / 100%;
                    .tipmark{
                        position: relative;
                        margin:12px 14px 0 28px;
                        height: 86px;
                        .sili{
                            position: absolute;
                            left: 0px;
                            top: 0px;
                            width: 100%;
                            height: 100%;
                            z-index: 2;
                            background-color: #fff;
                            border-radius: 15px;
                        }
                        i.el-icon-close{
                            position: absolute;
                            right: -24px;
                            top: 24px;
                            width: 40px;
                            height: 40px;
                            text-indent: 19px;
                            line-height: 40px;
                            background-color: #d2d0d0;
                            border-radius: 20px;
                            font-size: 16px;
                            color: #fff;
                            z-index: 1;
                            transition: all 0.2s;
                            -webkit-transition: all 0.2s;
                        }
                        i.el-icon-close:hover{
                            cursor: pointer;
                            color: red;
                        }
                    }
                }
                .line{
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    z-index: 1;
                    width:100%;
                    height:20px;
                    background-color: #fff;
                }
                .answercontent{
                    margin: 30px 20px 0px;
                    color: #666;
                    font-size: 14px;
                    line-height: 22px;
                    text-indent: 28px;
                }
                .chatmesgbox{
                    margin: 30px 20px 0px;
                    .chatmesg{
                        color: #666;
                        font-size: 14px;
                        line-height: 22px;
                        padding: 5px 10px;
                        display: inline-block;
                        // border-radius: 10px;
                        // border-top-left-radius:0px;
                        background-color: #fff;
                    }
                }
                .usermesgbox{
                    margin: 30px 20px 0px;
                    text-align: right;
                    .usermesg{
                        max-width: 400px;
                        color: #555;
                        font-size: 14px;
                        line-height: 22px;
                        padding: 5px 10px;
                        display: inline-block;
                        border-radius: 10px;
                        border-top-right-radius:0px;
                        background-color: rgba(var(--themecolor), 0.08);
                        text-align: left;
                    }
                }
            }
            .inputdiv{
                width: 100%;
                height: 120px;
                background-color: #fff;
                .inbox{
                    margin: 0 20px;
                    color: #666;
                    font-size: 14px;
                    border-radius: 5px;
                    border: 1px solid #ddd;
                    textarea{
                        resize: none;
                        border: none;
                        height: 75px;
                    }
                    .sendbox{
                        width: 100%;
                        height: 40px;
                        .lbtn{
                            float: left;
                            height:100%;
                            .cbtn{
                                float: left;
                                margin-top: 6px;
                                margin-left: 10px;
                                color: #666;
                                font-size: 14px;
                                height: 28px;
                                line-height: 28px;
                                padding: 0 15px 0 13px;
                                border-radius:10px;
                                background-color: #f5f5f5;
                                i.el-icon-upload2{
                                    margin-right: 3px;
                                }
                            }
                            .cbtn:hover{
                                cursor: pointer;
                                color: #555;
                                background-color: rgba(var(--themecolor), 0.05);
                            }
                            .qutips{
                                float: left;
                                margin-top: 8px;
                                margin-left: 10px;
                                color: #a9a9a9;
                                font-size: 18px;
                                width: 28px;
                                height: 28px;
                                line-height: 28px;
                                text-align:center;
                            }
                            .qutips:hover{
                                cursor: pointer;
                                color: #888;
                            }
                        }
                        .rbtn{
                            float: right;
                            height:100%;
                            .sendbtn{
                                display: inline-block;
                                width: 28px;
                                height:28px;
                                margin-top: 6px;
                                margin-right: 10px;
                                border-radius: 20px;
                                border: 2px solid #c9c9c9;
                                color: #979797;
                                font-size: 18px;
                                line-height: 28px;
                                text-align: center;
                                font-weight: bold;
                            }
                            .sendbtn:hover{
                                cursor: pointer;
                                color: rgba(var(--themecolor), 1);
                                border: 2px solid rgba(var(--themecolor), 1);
                            }
                        }
                    }
                }
            }
            .bot_botton{
                width: 100%;
                height: 52px;
                border-top: 1px solid #ddd;
                background-color: #fff;
                text-align:center;
                z-index: 1;
                position: relative;
                .botbtn{
                    display: inline-block;
                    height: 34px;
                    line-height: 34px;
                    text-align:center;
                    color: #fff;
                    font-size: 14px;
                    padding: 0 15px;
                    cursor: pointer;
                    border-radius: 5px;
                    margin: 8px 10px 0;
                    border:1px solid rgba(var(--themecolor), 0.8);
                    background-color: rgba(var(--themecolor), 0.8);
                    transition: all 0.2s;
                    -webkit-transition: all 0.2s;
                }
                .botbtn:hover{
                    border:1px solid rgba(var(--themecolor), 1);
                    background-color: rgba(var(--themecolor), 1);
                }
                .backbtn{
                    display: inline-block;
                    height: 34px;
                    line-height: 34px;
                    text-align:center;
                    color: #666;
                    font-size: 14px;
                    padding: 0 15px;
                    cursor: pointer;
                    border-radius: 5px;
                    margin: 8px 10px 0;
                    background-color: #fff;
                    border:1px solid #c7c7c7;
                    border-radius:5px;
                    transition: all 0.2s;
                    -webkit-transition: all 0.2s;
                }
                .backbtn:hover{
                    color: #555;
                    background-color: #f5f5f5;
                    border:1px solid #a7a7a7;
                }
            }
            .importbox{
                width: 100%;
                height:100%;
                position: absolute;
                left: 0;
                top: 0;
                z-index: 1;
                background-color: rgba(0,0,0,0.4);
                .flbox{
                    width: calc(100% - 100px);
                    height: calc(100% - 40px);
                    background-color: #fff;
                    border-radius: 5px;
                    position: absolute;
                    left: 50px;
                    top: 20px;
                    z-index: 2;
                    overflow: hidden;
                    .flback{
                        width: 100%;
                        height: 100%;
                        position: relative;
                        .fltit{
                            width: 100%;
                            height: 40px;
                            position: relative;
                            .tit{
                                color: #666;
                                font-size: 14px;
                                line-height: 40px;
                                text-align:center;
                            }
                            i.el-icon-close{
                                position: absolute;
                                right: 0px;
                                top: 0px;
                                width: 40px;
                                height: 40px;
                                line-height: 40px;
                                text-align: center;
                                font-size: 20px;
                                color: #c0c0c0;
                                transition: all 0.2s;
                                -webkit-transition: all 0.2s;
                            }
                            i.el-icon-close:hover{
                                cursor: pointer;
                                color: red;
                                transform: rotate(90deg);
                                -webkit-transform: rotate(90deg);
                            }
                        }
                        .testlist{
                            border: 1px solid #dad9d9;
                            border-radius: 5px;
                            opacity: 0;
                            height:calc(100% - 120px);
                            padding: 5px 0;
                            position: relative;
                            .tbtn{
                                width: 100%;
                                height: 24px;
                                position: absolute;
                                top: -24px;
                                left: 0;
                                z-index: 1;
                                .addtest{
                                    color: #fff;
                                    font-size: 12px;
                                    padding: 0 6px;
                                    height: 24px;
                                    line-height: 24px;
                                    cursor: pointer;
                                    margin-left: 20px;
                                    display: inline-block;
                                    border-bottom: none;
                                    border:1px solid rgba(var(--themecolor), 0.7);
                                    border-top-left-radius: 5px;
                                    border-top-right-radius: 5px;
                                    background-color: rgba(var(--themecolor), 0.7);
                                    i{
                                        margin-right: 3px;
                                        color: #fff;
                                    }
                                }
                                .addtest:hover{
                                    border:1px solid rgba(var(--themecolor), 0.8);
                                    background-color: rgba(var(--themecolor), 0.8);
                                }
                                .refresh{
                                    color: #888;
                                    font-size: 12px;
                                    padding: 0 6px;
                                    height: 24px;
                                    line-height: 24px;
                                    cursor: pointer;
                                    margin-left: 5px;
                                    display: inline-block;
                                    border:1px solid #dad9d9;
                                    border-bottom: none;
                                    border-top-left-radius: 5px;
                                    border-top-right-radius: 5px;
                                    i{
                                        margin-right: 3px;
                                        font-size: 11px;
                                    }
                                }
                                .refresh:hover{
                                    color: rgba(var(--themecolor), 0.8);
                                }
                            }
                            .testlistscroll{
                                width: 100%;
                                height: 100%;
                                .list{
                                    height: 40px;
                                    line-height: 40px;
                                    color: #666;
                                    font-size: 14px;
                                    margin: 15px 20px;
                                    border-radius: 5px;
                                    -webkit-box-shadow: 0 0 3px 3px #e1e1e1;
                                    box-shadow: 0 0 3px 3px #e1e1e1;
                                    transition: all 0.3s;
                                    -webkit-transition: all 0.3s;
                                    .index{
                                        float: left;
                                        color: #888;
                                        font-size: 12px;
                                        width: 20px;
                                        height: 20px;
                                        line-height: 20px;
                                        text-align: center;
                                        border:1px solid #ddd;
                                        border-radius:20px;
                                        margin:10px 10px 0 15px;
                                    }
                                    .name{
                                        width: calc(100% - 200px);
                                        float: left;
                                        height: 100%;
                                        text-indent: 10px;
                                    }
                                    .time{
                                        width: 150px;
                                        float: left;
                                        height: 100%;
                                        text-align:center;
                                    }
                                }
                                .list:hover{
                                    cursor: pointer;
                                    -webkit-box-shadow: 0 0 3px 3px rgba(var(--themecolor), 0.5);
                                    box-shadow: 0 0 3px 3px rgba(var(--themecolor), 0.5);
                                }
                                .notest{
                                    color: #666;
                                    font-size: 16px;
                                    text-align: center;
                                    margin-top:20px;
                                }
                                .iconfont{
                                    text-align: center;
                                    font-size: 50px;
                                    color: #999;
                                    margin-top:20px;
                                }
                                .totest{
                                    color:#888;
                                    font-size: 13px;
                                    display: inline-block;
                                    margin-top:20px;
                                    border:1px solid #ddd;
                                    border-radius:26px;
                                    height:26px;
                                    line-height:26px;
                                    padding:0 13px 0 15px;
                                    cursor: pointer;
                                }
                                .totest:hover{
                                    color:rgba(var(--themecolor), 0.8);
                                    border:1px solid #c5c5c5;
                                }
                            }
                        }
                        .testback{
                            width: 100%;
                            height: 50px;
                            background-color: #fff;
                            text-align: center;
                            .tbn{
                                display: inline-block;
                                margin-top: 10px;
                                color: #888;
                                font-size: 12px;
                                height: 28px;
                                line-height: 28px;
                                padding: 0 15px;
                                border-radius: 5px;
                                border: 1px solid #ddd;
                            }
                            .tbn:hover{
                                cursor: pointer;
                                color: rgba(var(--themecolor), 0.8);
                                border: 1px solid #cecece;
                            }
                        }
                        .cplayer{
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            left: 0;
                            top: 0;
                            z-index: 100;
                            background-color: rgba(255,255,255,0.3);
                        }
                        .cpleft{
                            width: 300px;
                            height: 100%;
                            background-color: #fff;
                            border-right:1px solid #ddd;
                            box-shadow: 0px 0px 5px 5px #e1e1e1;
                            position: absolute;
                            z-index: 102;
                            top:0px;
                            left: -300px;
                            .el-icon-arrow-left,.el-icon-arrow-right{
                                width: 50px;
                                height: 50px;
                                line-height:50px;
                                border-radius: 30px;
                                background-color: #fff;
                                color:#a3a3a3;
                                font-size:16px;
                                text-indent: 32px;
                                position: absolute;
                                right: -20px;
                                top:calc(50% - 25px);
                                z-index: 1;
                                transition: all 0.2s;
                                -webkit-transition: all 0.2s;
                                box-shadow: 0px 0px 5px 5px #e1e1e1;
                                cursor: pointer;
                            }
                            .ltit{
                                padding-left:10px;
                                height: 40px;
                                line-height:40px;
                                color:#888;
                                font-size:12px;
                                position: relative;
                                border-bottom:1px solid #ddd;
                                .el-icon-close{
                                    position: absolute;
                                    right:0px;
                                    top:0px;
                                    z-index:1;
                                    width:40px;
                                    line-height:40px;
                                    height:100%;
                                    text-align:center;
                                    font-size: 16px;
                                    color: #c0c0c0;
                                    transition: all 0.2s;
                                    -webkit-transition: all 0.2s;
                                }
                                .el-icon-close:hover{
                                    cursor: pointer;
                                    color: red;
                                    transform: rotate(90deg);
                                    -webkit-transform: rotate(90deg);
                                }
                            }
                            .litem{
                                width:100%;
                                height:calc(100% - 41px);
                                overflow-y: auto;
                                overflow-x: hidden;
                                width: 100%;
                                height: calc(100% - 41px);
                                overflow-y: auto;
                                overflow-x: hidden;
                                z-index: 2;
                                position: relative;
                                background-color: #fff;
                                .testbtn{
                                    margin: 15px 20px 0 20px;
                                    border: 1px solid #ddd;
                                    border-radius:5px;
                                    box-shadow: 1px 2px 3px 2px #e3e3e3;
                                    .cname{
                                        margin: 8px 12px 0;
                                        color: #5f5f5f;
                                        font-size: 16px;
                                        line-height: 24px;
                                    }
                                    .bul{
                                        height: 50px;
                                        text-align: center;
                                        .b{
                                            display: inline-block;
                                            height: 28px;
                                            line-height: 28px;
                                            padding: 0 20px;
                                            color: #7d7d7d;
                                            font-size: 12px;
                                            border-radius: 5px;
                                            cursor: pointer;
                                            margin: 11px 8px 0;
                                            background-color: #fff;
                                            border: 1px solid #ddd;
                                            i{
                                                margin-right:3px;
                                                color:#a0a0a0;
                                            }
                                        }
                                        .b:hover{
                                            color: rgba(var(--themecolor), 0.8);
                                            background-color: #f3f2f2;
                                        }
                                    }
                                }
                                .testbtn:hover{
                                    box-shadow: 1px 2px 5px 2px rgba(var(--themecolor), 0.3);
                                }
                            }
                        }
                        .testiframebox{
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            top: 0;
                            left: 0;
                            z-index: 103;
                            background-color: #fff;
                            .addiframe{
                                width:calc(100% - 20px);
                                height:calc(100% - 60px);
                                padding: 0 10px;
                                margin: 10px 10px 0;
                                border:1px solid #ddd;
                                border-radius:5px;
                            }
                            .ifbtn{
                                width: 100%;
                                height: 50px;
                                background-color: #fff;
                                text-align: center;
                                .ibtn{
                                    display: inline-block;
                                    margin-top: 10px;
                                    color: #888;
                                    font-size: 12px;
                                    height: 28px;
                                    line-height: 28px;
                                    padding: 0 15px;
                                    border-radius: 5px;
                                    border: 1px solid #ddd;
                                }
                                .ibtn:hover{
                                    cursor: pointer;
                                    color: rgba(var(--themecolor), 0.8);
                                    border: 1px solid #cecece;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .layerbox{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 100;
        background-color: rgba(0,0,0,0.4);
        .lbox{
            width: calc(100% - 60px);
            height: calc(100% - 40px);
            margin: 20px 30px;
            background-color: #fff;
            border-radius: 5px;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 2;
            overflow: hidden;
            .tab_box{
                width: 100%;
                height: 40px;
                position: relative;
                background-color: rgba(var(--themecolor),0.8);
                .tab{
                    display: inline-block;
                    height: 39px;
                    font-size: 18px;
                    color: #f6f6f6;
                    line-height: 40px;
                    padding: 0 20px 0 25px;
                    letter-spacing: 2px;
                    font-weight: bold;
                    font-style: italic;
                    text-shadow: 3px 3px 3px #888787;
                    i{
                        font-weight: bold;
                        display: inline-block;
                        height: 100%;
                        line-height: 40px;
                        width: 40px;
                        text-align: center;
                    }
                    img{
                        display: block;
                        float: left;
                        width: 32px;
                        margin: 6px 15px 0 0px;
                    }
                    .headanimate1{
                        display: inline-block;
                        height: 100%;
                        line-height: 40px;
                        text-align: center;
                        animation: animate_head1 6s ease 0s infinite;
                        -webkit-animation: animate_head1 6s ease 0s infinite;
                        @-webkit-keyframes animate_head1 {
                            0% {
                                color: #f6f6f6;
                            }
                            25% {
                                color: #f6f6f6;
                            }
                            29% {
                                color: #fa3e3e;
                            }
                            33% {
                                color: #f6f6f6;
                            }
                            100% {
                                color: #f6f6f6;
                            }
                        }
                        @keyframes animate_head1 {
                            0% {
                                color: #f6f6f6;
                            }
                            25% {
                                color: #f6f6f6;
                            }
                            29% {
                                color: #fa3e3e;
                            }
                            33% {
                                color: #f6f6f6;
                            }
                            100% {
                                color: #f6f6f6;
                            }
                        }
                    }
                    .headanimate2{
                        display: inline-block;
                        height: 100%;
                        line-height: 40px;
                        text-align: center;
                        animation: animate_head2 6s ease 0s infinite;
                        -webkit-animation: animate_head2 6s ease 0s infinite;
                        @-webkit-keyframes animate_head2 {
                            0% {
                                color: #f6f6f6;
                            }
                            58% {
                                color: #f6f6f6;
                            }
                            62% {
                                color: #fa3e3e;
                            }
                            66% {
                                color: #f6f6f6;
                            }
                            100% {
                                color: #f6f6f6;
                            }
                        }
                        @keyframes animate_head2 {
                            0% {
                                color: #f6f6f6;
                            }
                            58% {
                                color: #f6f6f6;
                            }
                            62% {
                                color: #fa3e3e;
                            }
                            66% {
                                color: #f6f6f6;
                            }
                            100% {
                                color: #f6f6f6;
                            }
                        }
                    }
                    .headanimate3{
                        display: inline-block;
                        height: 100%;
                        line-height: 40px;
                        text-align: center;
                        animation: animate_head3 6s ease 0s infinite;
                        -webkit-animation: animate_head3 6s ease 0s infinite;
                        @-webkit-keyframes animate_head3 {
                            0% {
                                color: #f6f6f6;
                            }
                            91% {
                                color: #f6f6f6;
                            }
                            95% {
                                color: #fa3e3e;
                            }
                            99% {
                                color: #f6f6f6;
                            }
                            100% {
                                color: #f6f6f6;
                            }
                        }
                        @keyframes animate_head3 {
                            0% {
                                color: #f6f6f6;
                            }
                            91% {
                                color: #f6f6f6;
                            }
                            95% {
                                color: #fa3e3e;
                            }
                            99% {
                                color: #f6f6f6;
                            }
                            100% {
                                color: #f6f6f6;
                            }
                        }
                    }
                }
                .close{
                    font-size: 13px;
                    color: #fafafa;
                    width: 40px;
                    height: 40px;
                    position: absolute;
                    right: 0;
                    top: 0;
                    z-index: 1;
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;
                }
                .close:hover{
                    color: #ffffff;
                }
            }
            .tab_con{
                width: 100%;
                height: calc(100% - 86px);
                .tab_scroll{
                    width: 100%;
                    height: 100%;
                    background-color: rgba(var(--themecolor),0.1);
                    .s_box{
                        margin: 0px 20px;
                        padding: 10px 0;
                        // border-bottom: 1px dashed #c4c2c2;
                        .tit{
                            color: #555;
                            font-size: 14px;
                            float: left;
                            width: 86px;
                            text-align: right;
                            font-weight: bold;
                            margin-top: 2px;
                        }
                        .box{
                            width: calc(100% - 86px);
                            float: left;
                            .el-button{
                                padding: 3px 8px 3px 12px;
                                margin: 0px 5px 10px;
                                border-radius: 20px;
                                color: #666;
                                font-size: 12px;
                                position: relative;
                                .num{
                                    position: absolute;
                                    right: -7px;
                                    top: -8px;
                                    z-index: 2;
                                    font-size: 8.5px;
                                    background-color: rgba(var(--themecolor), 0.75);
                                    color: #fff;
                                    width: 12px;
                                    height: 12px;
                                    border-radius: 12px;
                                    line-height: 12px;
                                    text-align: center;
                                    overflow: hidden;
                                }
                            }
                            i{
                                color: #999;
                                font-size: 12px;
                                margin-left: 3px;
                            }
                            .item{
                                display: inline-block;
                                color: #666;
                                font-size: 12px;
                                padding: 2px 10px;
                                border: 1px solid #bcbcbc;
                                border-radius: 20px;
                                margin: 0px 5px 10px;
                                transition: all 0.2s;
                                -webkit-transition: all 0.2s;
                                position: relative;
                                background-color: #fff;
                                .el-icon-caret-bottom{
                                    display: inline-block;
                                    width: 26px;
                                    height: 100%;
                                    text-align: center;
                                }
                                i{
                                    margin-left: 5px;
                                    color: #999;
                                }
                            }
                            .item:hover{
                                border: 1px solid rgba(var(--themecolor),0.85);
                                cursor: pointer;
                                color: rgba(var(--themecolor),0.75);
                            }
                            .item.on{
                                border: 1px solid rgba(var(--themecolor),0.85);
                                background-color: rgba(var(--themecolor),0.85);
                                color: #fff;
                            }
                            .item.on2{
                                border: 1px solid #ee7408;
                                background-color: #ee7408;
                                color: #fff;
                            }
                            .scopebox{
                                display: inline-block;
                                margin:  0 30px 5px 5px;
                            }
                            .el-input{
                                width: 80px;
                            }
                            .titmin{
                                margin-top: 1px;
                                color: #555;
                                font-size: 14px;
                            }
                            .ltxt{
                                color:#777;
                                font-size:14px;
                                margin-left: 10px;
                                display: inline-block;
                                line-height:1 !important;
                            }
                            .slider{
                                width: 360px;
                                height: 24px;
                                display: inline-block;
                                position: relative;
                                margin-left: 5px;
                                .range_slider{
                                    width: 360px;
                                    margin: auto;
                                }
                            }
                            .type{
                                display: inline-block;
                                color: #666;
                                font-size: 12px;
                                padding: 3px 12px;
                                border: 1px solid #bcbcbc;
                                border-radius: 5px;
                                margin: 0px 5px 6px;
                                transition: all 0.2s;
                                -webkit-transition: all 0.2s;
                                position: relative;
                                background-color: #fff;
                            }
                            .type:hover{
                                border: 1px solid rgba(var(--themecolor),0.85);
                                cursor: pointer;
                                color: rgba(var(--themecolor),0.85);
                            }
                            .type.on{
                                border: 1px solid rgba(var(--themecolor),0.85);
                                background-color: rgba(var(--themecolor),0.85);
                                color: #fff;
                            }
                        }
                        .cwbmark{
                            color: #666;
                            font-size: 14px;
                            height: 32px;
                            line-height: 32px;
                            margin-left: 5px;
                        }
                        .cwbbox{
                            margin-left: 5px;
                            .cwb{
                                font-size: 14px;
                                margin-right: 5px;
                                color: #666;
                            }
                            .cwb.c{
                                color: #d63434;
                            }
                            .cwb.w{
                                color: #ec8a20;
                            }
                            .cwb.b{
                                color: #1ebb72;
                            }
                            .el-input{
                                width: 100px;
                                margin-right: 30px;
                            }
                        }
                    }
                    .major_s_box {
                        display: flex;
                        align-items: center;
                        padding-bottom: 5px;
                        .major_number {
                            width: 190px;
                            .major_tips {
                                margin-right: 5px;
                                font-size: 13px;
                                color: #777;
                            }
                        }
                        .tips {
                            margin-left: 5px;
                            font-size: 14px;
                            color: #666;
                        }
                    }
                }
            }
            .btnbox{
                width: 100%;
                background-color: rgba(var(--themecolor),0.8);
                height: 46px;
                position: relative;
                .lbtnbox{
                    height: 100%;
                    img{
                        display: block;
                        float: left;
                        width: 28px;
                        margin: 10px 0 0 10px;
                    }
                    .tjstat{
                        color: #f6f6f6;
                        font-size: 14px;
                        float: left;
                        margin: 14px 0 0 5px;
                        .tjop{
                            margin-right: 7px;
                        }
                        .line{
                            display: inline-block;
                            height: 12px;
                            width: 1px;
                            background-color: #fff;
                            margin-right: 7px;
                        }
                        .num{
                            font-size: 15px;
                            color: #f6f6f6;
                            font-weight: bold;
                            margin:0px 2px;
                        }
                    }
                }
                .rbtnbox{
                    height: 100%;
                    position: absolute;
                    right:0;
                    top:0;
                    z-index: 1;
                    .btn{
                        display: inline-block;
                        border-radius: 5px;
                        text-align: center;
                        letter-spacing: 1px;
                        cursor: pointer;
                    }
                    .b1{
                        color: #e7e7e7;
                        font-size: 12px;
                        border: 1px solid rgba(var(--themecolor), 1);
                        background-color: rgba(var(--themecolor), 0.5);
                        padding: 0 8px;
                        margin: 9px 0px 0px 18px;
                        height: 28px;
                        line-height: 28px;
                    }
                    .b1:hover{
                        color: #fff;
                        background-color: rgba(var(--themecolor), 0.8);
                    }
                    .b2{
                        background-color: #f6f6f6;
                        color: #4d4c4c;
                        font-size: 14px;
                        padding: 0 20px;
                        height: 34px;
                        line-height: 34px;
                        margin: 6px 20px 0 20px;
                        font-weight: bold;
                    }
                    .b2:hover{
                        color: rgba(var(--themecolor),1);
                        background-color: #fff;
                    }
                }
            }
        }
    }
    .wish_table_layer{
        width: 100%;
        background-color: #fff;
        .top_fixed {
            line-height: 1.5;
            padding: 3px 10px 0;
            .type{
                width: calc(100% - 576px);
                display: inline-block;
                .yname{
                    font-size: 14px;
                    color: #555;
                    margin-left: 10px;
                }
            }
            .info{
                margin: 5px 0 5px;
                display: inline-block;
                font-size: 13px;
                display: flex;
                .user-name {
                    width: 53px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    color: rgba(var(--themecolor), 0.9);
                    text-align: center;
                }
                .yname{
                    color: #555;
                    margin-right: 5px;
                }
                .exam{
                    color: #555;
                    span{
                        margin-right: 5px;
                    }
                    .rank {
                        margin-left: 5px;
                        color: #666;
                    }
                }
            }
        }
        .wish_table{
            .wish_box{
                margin: 0px 10px;
                border: 1px solid #dfdddd;
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
                border-bottom: none;
                .mark-tips{
                    border: 1px dashed rgba(var(--themecolor),0.6);
                    border-radius: 5px;
                    padding: 5px 0;
                    margin: 10px 10px 0;
                    background-color: #fff;
                    span{
                        display: inline-block;
                        margin: 3px 15px;
                        color: #777;
                        font-size: 13px;
                    }
                }
                .userbox{
                    margin: 5px 0px 10px;
                    background-color: #fff;
                    border-radius: 5px;
                    .type{
                        padding: 20px 10px 0;
                        width: calc(100% - 475px);
                        display: inline-block;
                        .vip{
                            border: 3px solid rgba(var(--themecolor),0.3);
                            color: #da8824;
                            font-size: 16px;
                            padding: 2px 15px;
                            border-radius: 5px;
                            display: inline-block;
                            letter-spacing: 2px;
                            font-weight: bold;
                            font-style: italic;
                            position: relative;
                            i{
                                text-align: center;
                                color: #e6b738;
                                font-size: 20px;
                                margin-right: 5px;
                                position: absolute;
                                left: -11px;
                                top: -16px;
                                z-index: 1;
                            }
                        }
                        .tname{
                            font-size: 20px;
                            color: #333;
                            margin-left: 10px;
                            span{
                                color: #666;
                            }
                        }
                        .yname{
                            font-size: 16px;
                            color: #555;
                            margin-left: 10px;
                        }
                    }
                    .info{
                        width: calc(100% - 475px);
                        margin: 15px 20px 5px;
                        padding-bottom: 10px;
                        display: inline-block;
                        .exam{
                            font-size: 14px;
                            color: #555;
                            span{
                                margin-right: 20px;
                            }
                        }
                    }
                    .bott{
                        width: 475px;
                        height: 34px;
                        float: right;
                        text-align: right;
                        margin-top: 20px;
                        span{
                            height: 34px;
                            line-height: 34px;
                            border-radius: 5px;
                            margin: 0px 10px;
                            background-color: rgba(var(--themecolor),0.8);
                            color: #fff;
                            font-size: 14px;
                            display: inline-block;
                            padding: 0 20px;
                            cursor: pointer;
                            i{
                                margin-right: 5px;
                            }
                        }
                        span:hover{
                            background-color: rgba(var(--themecolor),1);
                        }
                    }
                }
                .theadtitle{
                    margin: 0 10px;
                    padding-bottom: 5px;
                    .txt{
                        color: #666;
                        font-size: 14px;
                        line-height: 40px;
                        b{
                            color: rgba(var(--themecolor),1);
                            font-size: 18px;
                        }
                    }
                    .sort{
                        float: right;
                        height: 40px;
                        line-height: 40px;
                        .tit{
                            color: #666;
                            font-size: 14px;
                            height: 40px;
                            float: left;
                            display: block;
                            margin-left: 15px;
                            .ico{
                                margin-right: 3px;
                                // color: #b6b6b6;
                                color: rgba(var(--themecolor),0.5);
                                font-size: 16px;
                                margin-right: 8px;
                            }
                            .tt{
                                float: left;
                                display: block;
                                height: 40px;
                                border-left: 1px dashed #c0bebe;
                                padding-left: 18px;
                            }
                            .icon{
                                float: left;
                                display: block;
                                width: 26px;
                                height: 40px;
                                i{
                                    width: 100%;
                                    height: 20px;
                                    line-height: 20px;
                                    text-align: center;
                                    display: block;
                                    font-size: 20px;
                                    color: #c9c9c9;
                                }
                                i.on{
                                    color: rgba(var(--themecolor),0.9);
                                }
                                i:hover{
                                    cursor: pointer;
                                    color: rgba(var(--themecolor),0.8);
                                }
                                i:first-child{
                                    line-height: 24px;
                                }
                                i:last-child{
                                    line-height: 16px;
                                }
                            }
                        }
                    }
                }
            }
        }
        .wish_t_h{
            width: 100%;
            height: 40px;
            .wish_t_fixed{
                width: 100%;
                height: 40px;
                .wish_head{
                    user-select: none;
                    .htable{
                        margin: auto 10px;
                        border-left: 1px solid #ddd;
                        border-right: 1px solid #ddd;
                        .head{
                            margin: 0px 10px;
                            background-color: #f5ecec;
                            height: 40px;
                            line-height: 40px;
                            color: #555;
                            font-size: 14px;
                            border: 1px solid #ddd;
                            border-bottom: none;
                            border-top-left-radius: 5px;
                            border-top-right-radius: 5px;
                            .td{
                                text-align: center;
                                border-left: 1px solid #ddd;
                                float: left;
                                .t{
                                    border-bottom: 1px solid #ddd;
                                    height: 20px;
                                    line-height: 20px;
                                }
                                .year{
                                    height: 20px;
                                    line-height: 20px;
                                    .y{
                                        float: left;
                                        width: calc((100% - 2px) / 3);
                                        border-left: 1px solid #ddd;
                                        font-size: 14px;
                                        color: #777;
                                    }
                                    .y:first-child{
                                        border-left:none;
                                    }
                                }
                            }
                            .td:nth-child(1){
                                width: 46px;
                                border-left:none;
                            }
                            .td:nth-child(2){
                                width: 240px;
                            }
                            .td:nth-child(3){
                                width: 47px;
                            }
                            .td:nth-child(4){
                                width: 251px;
                            }
                            .td:nth-child(5){
                                width: 150px;
                            }
                            .td:nth-child(6){
                                width: calc(100% - 734px);
                            }
                        }
                        .majorgroup{
                            .td:nth-child(2){
                                width: 250px;
                            }
                            .td:nth-child(3){
                                width: 250px;
                            }
                            .td:nth-child(4){
                                width: 140px;
                            }
                            .td:nth-child(5){
                                width: calc(100% - 686px);
                            }
                        }
                    }
                }
            }
            .wish_t_fixed.fixed{
                position: fixed;
                top: 40px;
                left: 0px;
                z-index: 99;
            }
        }
        .wish_t_l{
            width: 100%;
            .wish_t_m{
                user-select: none;
                .wtable{
                    margin: 0px 10px 0px;
                    border: 1px solid #ddd;
                    border-top: none;
                    border-bottom-left-radius: 5px;
                    border-bottom-right-radius: 5px;
                    .table{
                        margin: 0px 10px 10px;
                        border: 1px solid #ddd;
                        border-bottom-left-radius: 5px;
                        border-bottom-right-radius: 5px;
                        background-color: #fff;
                        tr td.move:hover{
                            cursor: move;
                        }
                        tr td.move {
                            position: relative;

                            .toggle {
                                padding: 2px 5px;
                                font-size: 12px;
                                border-radius: 2px;
                                cursor: pointer;
                                box-shadow: 0 0 6px #d1d1d3;
                                border: 1px solid #dadadd;

                                transform: scale(0.9);

                                position: absolute;
                                top: 1px;
                                left: 0px;

                                &:hover {
                                    background-color: #efefff;
                                    box-shadow: 0 0 1px #dadada;
                                }
                            }
                            .click-name {
                                &:hover {
                                    cursor: pointer;
                                }
                            }
                            .delete-status {
                                position: absolute;
                                top: 3px;
                                right: 3px;
                                font-size: 12px;
                                color: red;
                            }
                            .college-major {
                                right: 50px;
                            }
                            .replace {
                                padding: 2px 5px;
                                font-size: 12px;
                                border-radius: 2px;
                                cursor: pointer;
                                box-shadow: 0 0 6px #d1d1d3;
                                border: 1px solid #dadadd;

                                transform: scale(0.9);

                                position: absolute;
                                top: 1px;
                                right: 0px;

                                &:hover {
                                    background-color: #efefff;
                                    box-shadow: 0 0 1px #dadada;
                                }

                                .replace-icon {
                                    transform: rotateZ(90deg);
                                }
                            }

                            .add-major {
                                position: absolute;
                                bottom: 3px;
                                right: 3px;

                                padding: 2px 5px;
                                font-size: 12px;
                                box-shadow: 0 0 6px #d1d1d3;
                                color: #0076bf;
                                &:hover {
                                    cursor: pointer;

                                    background-color: #efefff;
                                    box-shadow: 0 0 1px #d1d1d3;
                                }
                            }
                        }
                        tr{
                            color: #666;
                            font-size: 14px;
                            td{
                                padding: 0 5px;
                                border-left: 1px solid #ddd;
                                border-bottom: 2px solid #ddd;
                                .Group-name{
                                    position: absolute;
                                    left: 5px;
                                    top: 0;
                                    z-index: 1;
                                    font-size: 13px;
                                }
                                .Group-name.c{
                                    color: #d63434;
                                }
                                .Group-name.w{
                                    color: #ec8a20;
                                }
                                .Group-name.b{
                                    color: #1ebb72;
                                }
                                .c_name{
                                    color: #555;
                                    font-size: 20px;
                                    line-height: 24px;
                                    position: relative;
                                    padding: 0 20px;
                                    
                                    .level {
                                        font-size: 13px;
                                    }
                                }
                                .s_txt{
                                    font-size: 12px;
                                    margin-top: 2px;
                                    // overflow: hidden;
                                    // text-overflow: ellipsis;
                                    span{
                                        margin: 0px 5px;
                                        // display: block;
                                    }
                                    .types{
                                        font-size: 12px;
                                        display: block;
                                        line-height: 20px;
                                    }
                                    .tipss{
                                        font-size: 12px;
                                        color: #888;
                                        overflow: hidden;
                                        display: inline-block;
                                        line-height: 20px;
                                        span{
                                            padding: 0 5px;
                                            border-left: 1px solid #ddd;
                                            display: inline-block;
                                            height: 12px;
                                            line-height: 12px;
                                        }
                                        span:first-child{
                                            border-left:none;
                                            padding-left: 0;
                                        }
                                    }
                                }
                                .num{
                                    display: inline-block;
                                    width:36px;
                                    height: 18px;
                                    text-align: center;
                                    line-height: 18px;
                                    background-color: #fff;
                                    color: rgba(var(--themecolor),1);
                                    font-size: 14px;
                                    border: 1px solid rgba(var(--themecolor),0.25);
                                    border-radius: 3px;
                                    overflow: hidden;
                                    i{
                                        font-size: 12px;
                                        color: #999;
                                        margin-left: 2px;
                                    }
                                }
                                .num:hover{
                                    cursor: pointer;
                                    border: 1px solid rgba(var(--themecolor),0.4);
                                }
                                .major{
                                    padding: 18px 10px 0;
                                    .name{
                                        color: #555;
                                        font-size: 18px;
                                        line-height: 22px;
                                        margin-bottom: 2px;
                                        position: relative;
                                        padding: 0 20px;
                                        .Group-name{
                                            left: 0px;
                                        }
                                        .zyxb{
                                            .el-button{
                                                font-size: 12px;
                                                color: #ee7408;
                                                padding: 1px 1px;
                                                margin-left: 5px;
                                                cursor: default;
                                            }
                                        }
                                    }
                                    .major-name {
                                        &:hover {
                                            cursor: pointer;
                                        }
                                    }
                                    .mx{
                                        font-size: 12px;
                                        margin: 5px 0;
                                        span{
                                            margin-right:10px;
                                        }
                                        .sbtips{
                                            display: inline-block;
                                            padding: 2px 5px;
                                            color: #3e80b9;
                                            background-color: #c8e4f4;
                                            font-size: 12px;
                                            border-radius: 3px;
                                            position: relative;
                                        }
                                    }
                                }
                                .score{
                                    font-size: 14px;
                                    color: rgba(var(--themecolor),1);
                                    display: block;
                                    .isadjuststr{
                                        margin-left: 10px;
                                        font-size: 12px;
                                        color: #666;
                                    }
                                }
                            }
                            td:nth-child(1){
                                width: 40px;
                                border-left:none;
                                text-align: center;
                                position: relative;
                                i.el-icon-top,i.el-icon-bottom{
                                    display: inline-block;
                                    font-size: 18px;
                                    color: #999;
                                    width: 22px;
                                    height: 22px;
                                    line-height: 22px;
                                }
                                i.el-icon-top:hover,i.el-icon-bottom:hover{
                                    cursor: pointer;
                                    color: rgba(var(--themecolor),1);
                                }
                                i.el-icon-delete{
                                    width: 22px;
                                    height: 22px;
                                    line-height: 22px;
                                    font-size: 14px;
                                    margin-top: 2px;
                                    color: #999;
                                    display: inline-block;
                                    cursor: pointer;
                                }
                                i.el-icon-delete:hover{
                                    color: rgba(var(--themecolor),1);
                                }
                            }
                            td:nth-child(2){
                                width: 240px;
                                text-align: center;
                                padding: 18px 0 24px;
                            }
                            td:nth-child(3){
                                padding: 0;
                                tr:last-child td{
                                    border-bottom:none;
                                }
                                td{
                                    border-bottom: 1px solid #ddd;
                                    .person{
                                        color: #777;
                                        font-size: 12px;
                                        margin-bottom: 2px;
                                        span{
                                            color: #555;
                                            font-size: 18px;
                                        }
                                    }
                                    .md{
                                        color: #888;
                                        font-size: 12px;
                                    }
                                }
                                td:nth-child(1){
                                    width: 30px;
                                    text-align: center;
                                    i.el-icon-top,i.el-icon-bottom{
                                        display: inline-block;
                                        font-size: 18px;
                                        color: #999;
                                        width: 22px;
                                        height: 22px;
                                        line-height: 22px;
                                    }
                                    i.el-icon-top:hover,i.el-icon-bottom:hover{
                                        cursor: pointer;
                                        color: rgba(var(--themecolor),1);
                                    }
                                    i.el-icon-top{
                                        // margin-bottom: 5px;
                                    }
                                    i.el-icon-bottom{
                                        // margin-top: 5px;
                                    }
                                    i.el-icon-delete{
                                        width: 22px;
                                        height: 22px;
                                        line-height: 22px;
                                        font-size: 14px;
                                        margin-top: 2px;
                                        color: #999;
                                        display: inline-block;
                                        cursor: pointer;
                                    }
                                    i.el-icon-delete:hover{
                                        color: rgba(var(--themecolor),1);
                                    }
                                }
                                td:nth-child(2){
                                    width: 250px;
                                }
                                td:nth-child(3){
                                    text-align: center;
                                    width: 150px;
                                    border-left: 1px dashed #b8b8b8;
                                }
                                td:nth-child(4){
                                    border-left: 1px dashed #b8b8b8;
                                    padding: 10px 0;
                                    .MajorLimitItemStyle{
                                        position: absolute;
                                        top: 0px;
                                        left: -130px;
                                        display: inline-block;
                                        z-index: 1;
                                        width: calc(100% + 130px);
                                        height: 100%;
                                        .MajorLimitItemCon{
                                            width: 100%;
                                            height: 100%;
                                            overflow-y: auto;
                                            border-radius: 3px;
                                            border-top-left-radius: 0px;
                                            background-color: rgba(0,0,0,0.7);
                                            color:#fff;
                                            padding: 5px;
                                            .mltips{
                                                color: #fd7f7f;
                                                font-size: 12px;
                                                margin: 0 0 5px;
                                            }
                                            .mltitle{
                                                font-size: 12px;
                                            }
                                            .mlitem{
                                                font-size: 12px;
                                                display: inline-block;
                                                margin: 3px 5px 0px 0px;
                                                padding: 2px 5px;
                                                background-color: #ee7408;
                                                border-radius: 2px;
                                            }
                                        }
                                        .mlclose{
                                            position: absolute;
                                            left: -20px;
                                            top: 0px;
                                            z-index: 2;
                                            width: 20px;
                                            height: 20px;
                                            color: #fff;
                                            font-size: 16px;
                                            cursor: pointer;
                                            background-color: rgba(0,0,0,0.7);
                                            text-align: center;
                                            line-height: 20px;
                                        }
                                        .el-icon-d-arrow-left{
                                            transform: rotate(-90deg);
                                            border-radius: 3px;
                                        }
                                        .el-icon-d-arrow-right{
                                            transform: rotate(-90deg);
                                            border-top-right-radius: 3px;
                                            border-top-left-radius: 3px;
                                        }
                                    }
                                    .ls{
                                        width: calc((100% - 2px) / 3);
                                        display: inline-block;
                                        border-left: 1px dashed #b8b8b8;
                                        span{
                                            display: block;
                                            line-height: 20px;
                                            text-align: center;
                                            color: #666;
                                            font-size: 12px;
                                        }
                                        .zhengji{
                                            position: absolute;
                                            right: 5px;
                                            top: -12px;
                                            z-index: 1;
                                            color: #fff;
                                            font-size: 10px;
                                            background-color: #13c0b7;
                                            border-radius: 20px;
                                            line-height: 16px;
                                            text-align: center;
                                            width: 16px;
                                            height: 16px;
                                            span{
                                                line-height: 16px;
                                                font-size: 12px;
                                                color: #fff;
                                            }
                                            .zjtxt{
                                                position: absolute;
                                                bottom: -35px;
                                                left: -75px;
                                                width: 150px;
                                                height: 30px;
                                                line-height: 30px;
                                                color: #fff;
                                                font-size: 14px;
                                                background-color: rgba(0, 0, 0, 0.8);
                                                z-index: 999;
                                                border-radius: 5px;
                                                text-align: center;
                                                display: none;
                                            }
                                            &:hover{
                                                cursor: pointer;
                                                .zjtxt{
                                                    display: block;
                                                }
                                            }
                                        }
                                    }
                                    .ls:first-child{
                                        border-left:none;
                                    }

                                    .tips {
                                        display: flex;
                                        span {
                                            display: inline;
                                        }
                                    }
                                    .tips-text {
                                        position: relative;
                                        .icon {
                                            height: 14px;
                                            position: absolute;
                                            top: 0px;
                                        }
                                        &:hover {
                                            cursor: default;
                                            .show-text {
                                                display: block;
                                                cursor: default;
                                                text-align: left !important;
                                            }
                                        }
                                        .show-text {
                                            display: none;
                                            width: 200px;
                                            padding: 5px;
                                            border-radius: 5px;
                                            background-color: rgba(0,0,0,0.5);
                                            color: #fff;
                                            position: absolute;
                                            top: -88px;
                                            left: -100px;
                                            z-index: 2;
                                            text-align: left !important;
                                        }
                                    }
                                    
                                }
                            }
                        }
                        tr:last-child td{
                            border-bottom:none;
                        }
                    }
                    .majorgroup{
                        tr td{
                            text-align: center;
                            .person{
                                color: #777;
                                font-size: 12px;
                                margin-bottom: 2px;
                                span{
                                    color: #555;
                                    font-size: 18px;
                                }
                            }
                            .md{
                                color: #888;
                                font-size: 12px;
                            }
                            .score{
                                font-size: 14px;
                                color: rgba(var(--themecolor),1);
                                display: block;
                            }
                        }
                        tr td:nth-child(1){
                            i.el-icon-top{
                                // margin-bottom: 5px;
                            }
                            i.el-icon-bottom{
                                // margin-top: 5px;
                            }
                            i.el-icon-delete{
                                margin-top: 2px;
                            }
                        }
                        tr td:nth-child(2){
                            width: 250px;
                        }
                        // tr td:nth-child(2){
                        //     width: 290px;
                        // }
                        tr td:nth-child(3){
                            width: 250px;
                            padding: 0px 10px;
                        }
                        tr td:nth-child(4){
                            width: 140px;
                        }
                        tr td:nth-child(5){
                            padding: 10px 0;
                            .MajorLimitItemStyle{
                                position: absolute;
                                top: 0px;
                                left: -120px;
                                display: inline-block;
                                z-index: 1;
                                width: calc(100% + 120px);
                                height: 100%;
                                text-align: left;
                                .MajorLimitItemCon{
                                    width: 100%;
                                    height: 100%;
                                    overflow-y: auto;
                                    border-radius: 3px;
                                    border-top-left-radius: 0px;
                                    background-color: rgba(0,0,0,0.7);
                                    color:#fff;
                                    padding: 5px;
                                    .mltips{
                                        color: #fd7f7f;
                                        font-size: 12px;
                                        margin: 0 0 5px;
                                    }
                                    .mltitle{
                                        font-size: 12px;
                                    }
                                    .mlitem{
                                        font-size: 12px;
                                        display: inline-block;
                                        margin: 3px 5px 0px 0px;
                                        padding: 2px 5px;
                                        background-color: #ee7408;
                                        border-radius: 2px;
                                    }
                                }
                                .mlclose{
                                    position: absolute;
                                    left: -20px;
                                    top: 0px;
                                    z-index: 2;
                                    width: 20px;
                                    height: 20px;
                                    color: #fff;
                                    font-size: 16px;
                                    cursor: pointer;
                                    background-color: rgba(0,0,0,0.7);
                                    text-align: center;
                                    line-height: 20px;
                                }
                                .el-icon-d-arrow-left{
                                    transform: rotate(-90deg);
                                    border-radius: 3px;
                                }
                                .el-icon-d-arrow-right{
                                    transform: rotate(-90deg);
                                    border-top-right-radius: 3px;
                                    border-top-left-radius: 3px;
                                }
                            }
                            .ls{
                                width: calc((100% - 2px) / 3);
                                display: inline-block;
                                border-left: 1px dashed #b8b8b8;
                                span{
                                    display: block;
                                    line-height: 20px;
                                    text-align: center;
                                    color: #666;
                                    font-size: 12px;
                                }
                                .zhengji{
                                    position: absolute;
                                    right: 5px;
                                    top: -12px;
                                    z-index: 1;
                                    color: #fff;
                                    font-size: 10px;
                                    background-color: #13c0b7;
                                    border-radius: 20px;
                                    line-height: 16px;
                                    text-align: center;
                                    width: 16px;
                                    height: 16px;
                                    span{
                                        line-height: 16px;
                                        font-size: 12px;
                                        color: #fff;
                                    }
                                    .zjtxt{
                                        position: absolute;
                                        bottom: -35px;
                                        left: -75px;
                                        width: 150px;
                                        height: 30px;
                                        line-height: 30px;
                                        color: #fff;
                                        font-size: 14px;
                                        background-color: rgba(0, 0, 0, 0.8);
                                        z-index: 999;
                                        border-radius: 5px;
                                        text-align: center;
                                        display: none;
                                    }
                                    &:hover{
                                        cursor: pointer;
                                        .zjtxt{
                                            display: block;
                                        }
                                    }
                                }
                            }
                            .ls:first-child{
                                border-left:none;
                            }
                            .tips {
                                display: flex;
                                span {
                                    display: inline;
                                }
                            }
                            .tips-text {
                                position: relative;
                                .icon {
                                    height: 14px;
                                    position: absolute;
                                    top: 0px;
                                }
                                &:hover {
                                    cursor: default;
                                    .show-text {
                                        display: block;
                                        cursor: default;
                                        text-align: left !important;
                                    }
                                }
                                .show-text {
                                    display: none;
                                    width: 200px;
                                    padding: 5px;
                                    border-radius: 5px;
                                    background-color: rgba(0,0,0,0.5);
                                    color: #fff;
                                    position: absolute;
                                    top: -88px;
                                    left: -100px;
                                    z-index: 2;
                                    text-align: left !important;
                                }
                            }
                        }
                    }
                    .nowish{
                        width: 100%;
                        text-align: center;
                        line-height: 300px;
                        color: #666;
                        font-size: 16px;
                    }
                }
            }
        }
    }
}
</style>
<style lang="less">
.testlikeimportbox .tbox .el-scrollbar__wrap{
    overflow-x: hidden;
}
.fastwish_start .layerbox .lbox .tab_con .el-scrollbar__wrap{
    overflow-x: hidden;
}
.fastwish_start .layerbox .tab_con .s_box .el-input__inner{
    text-align:center;
}
.fastwish_start .layerbox .lbox .tab_con .tab_scroll .s_box .box .slider .el-slider__button{
    border:none;
    color: #fff;
    font-size: 13px;
    width: 40px;
    height: 18px;
    border-radius: 40px;
    line-height: 18px;
    background-color:rgba(var(--themecolor), 1);
}
.fastwish_start .layerbox .lbox .tab_con .tab_scroll .s_box .box .slider .el-slider__button-wrapper{
    width: auto !important;
    z-index: 1 !important;
}
.fastwish_start .layerbox .lbox .tab_con .tab_scroll .s_box .box .el-cascader .el-cascader__tags{
    right:50px;
}
.fastwish_start .layerbox .lbox .tab_con .tab_scroll .s_box .box .el-cascader .el-input__suffix{
    width:40px;
    border-left: 1px dashed #bababa;
    .el-input__icon{
        width:40px;
        font-size: 18px;
    }
}
</style>